import { environment } from "src/environment/environment";

export const ERPURL: string = environment.erpURL;

export const NishwikMaster: string = ERPURL + '/AM';

export const CRM: string = ERPURL + '/CRM';
export const SupportDesk: string = ERPURL + '/SPD';
export const HRMS: string = ERPURL + '/HRMS';
export const ERP: string = ERPURL + '/ERP';
export const Notification: string = ERPURL + '/NT'
export const PMS: string = ERPURL + '/PMS';
export const BIR: string = ERPURL + '/BIR';                                                                                                                                                                  
export const AI: string = ERPURL + '/AI'

export const Master: string = ERP + '/MA';
export const Billing: string = ERP + '/BI';

export const DevOps: string = ERPURL + '/DO';
export const Payroll: string = ERPURL + '/PR';
export const EPC: string = CRM + '/EPC'

//#region AddressDetail API
export const AddressDetailURL: string = NishwikMaster + '/AD';
export const AddressDetail_create = AddressDetailURL + '/Create';
export const AddressDetail_update = AddressDetailURL + '/Update';
export const AddressDetail_readById = AddressDetailURL + '/ReadById';
export const AddressDetail_readAll = AddressDetailURL + '/ReadAll';
export const AddressDetail_readByMasterId = AddressDetailURL + '/ReadByMasterId';
export const AddressDetail_delete = AddressDetailURL + '/Delete';
//#endregion

//#region BranchMaster API
export const BranchMasterURL: string = NishwikMaster + '/BM';
export const BranchMaster_create = BranchMasterURL + '/Create';
export const BranchMaster_update = BranchMasterURL + '/Update';
export const BranchMaster_readById = BranchMasterURL + '/ReadById';
export const BranchMaster_readAll = BranchMasterURL + '/ReadAll';
export const BranchMaster_delete = BranchMasterURL + '/Delete';
export const BranchMaster_ReadByUserId = BranchMasterURL + '/ReadByUserId';
export const BranchMaster_GetDictionary = BranchMasterURL + '/GetDictionary';
export const BranchMaster_readyCompanyId = BranchMasterURL + '/ReadByCompanyId'
//#endregion


//#region BranchMaster API
export const BranchRelationURL: string = NishwikMaster + '/BR';
export const BranchRelation_create = BranchRelationURL + '/Create';
export const BranchRelation_update = BranchRelationURL + '/Update';
export const BranchRelation_readById = BranchRelationURL + '/ReadById';
export const BranchRelation_readAll = BranchRelationURL + '/ReadAll';
export const BranchRelation_delete = BranchRelationURL + '/Delete';
export const BranchRelation_readByBranchId = BranchRelationURL + '/ReadByBranchId'
//#endregion

//#region Cities API
export const CitiesURL: string = NishwikMaster + '/CT';
export const Cities_create = CitiesURL + '/Create';
export const Cities_update = CitiesURL + '/Update';
export const Cities_delete = CitiesURL + '/Delete';
export const Cities_readById = CitiesURL + '/ReadById';
export const Cities_readAll = CitiesURL + '/ReadAll';
export const Cities_readAllPaginated = CitiesURL + '/ReadAllPaginated'
//#endregion

//#region CompanyConfig API
export const CompanyConfigURL: string = NishwikMaster + '/CC';
export const CompanyConfig_create = CompanyConfigURL + '/Create';
export const CompanyConfig_update = CompanyConfigURL + '/Update';
export const CompanyConfig_readById = CompanyConfigURL + '/ReadById';
export const CompanyConfig_readAll = CompanyConfigURL + '/ReadAll';
export const CompanyConfig_readByCompanyId = CompanyConfigURL + '/ReadByCompanyId';
export const CompanyConfig_delete = CompanyConfigURL + '/Delete';
//#endregion

//#region CompanyMaster API
export const CompanyMasterURL: string = NishwikMaster + '/CM';
export const CompanyMaster_create = CompanyMasterURL + '/Create';
export const CompanyMaster_update = CompanyMasterURL + '/Update';
export const CompanyMaster_readAll = CompanyMasterURL + '/ReadAll';
export const CompanyMaster_readById = CompanyMasterURL + '/ReadById';
export const CompanyMaster_delete = CompanyMasterURL + '/Delete';
export const CompanyMaster_readAllPaginated = CompanyMasterURL + '/ReadAllPaginated';
export const ComapnyMaster_SearchByName = CompanyMasterURL + '/SearchByName';
export const CompanyMaster_SearchByNameLogin = CompanyMasterURL + '/SearchByNameLogin';
export const CompanyMaster_readByUserId = CompanyMasterURL + '/ReadByUserId';
export const CompanyMaster_GetDictionary = CompanyMasterURL + '/GetDictionary'
//#endregion

//#region CompanyRelation API
export const CompanyRelationURL: string = NishwikMaster + '/CR';
export const CompanyRelation_create = CompanyRelationURL + '/Create';
export const CompanyRelation_update = CompanyRelationURL + '/Update';
export const CompanyRelation_readAll = CompanyRelationURL + '/ReadAll';
export const CompanyRelation_readById = CompanyRelationURL + '/ReadById';
export const CompanyRelation_readByCompanyId = CompanyRelationURL + '/ReadByCompanyId';
export const CompanyRelation_delete = CompanyRelationURL + '/Delete';
export const CompanyRelation_GetSupplierDictionary = CompanyRelationURL + '/GetSupplierDictionary'
//#endregion

//#region CompanySoftwareMapping API
export const CompanySoftwareMappingURL: string = NishwikMaster + '/CSM';
export const CompanySoftwareMapping_create = CompanySoftwareMappingURL + '/Create';
export const CompanySoftwareMapping_update = CompanySoftwareMappingURL + '/Update';
export const CompanySoftwareMapping_readById = CompanySoftwareMappingURL + '/ReadById';
export const CompanySoftwareMapping_readByBranchId = CompanySoftwareMappingURL + '/ReadByBranchId';
export const CompanySoftwareMapping_readByCompanyId = CompanySoftwareMappingURL + '/ReadByCompanyId';
export const CompanySoftwareMapping_readBySoftwareId = CompanySoftwareMappingURL + '/ReadBySoftwareId';
export const CompanySoftwareMapping_delete = CompanySoftwareMappingURL + '/Delete';
//#endregion


//#region CompanyWhiteLabel API
export const CompanyWhiteLabel: string = NishwikMaster + '/CWL';
export const CompanyWhiteLabel_create = CompanyWhiteLabel + '/Create';
export const CompanyWhiteLabel_update = CompanyWhiteLabel + '/Update';
export const CompanyWhiteLabel_readAll = CompanyWhiteLabel + '/ReadAll';
export const CompanyWhiteLabel_readById = CompanyWhiteLabel + '/ReadById';
export const CompanyWhiteLabel_readByCompanyId = CompanyWhiteLabel + '/ReadByCompanyId';
export const CompanyWhiteLabel_delete = CompanyWhiteLabel + '/Delete';
//#endregion

//#region ContactDetail API
export const ContactDetailURL: string = NishwikMaster + '/CD';
export const ContactDetail_create = ContactDetailURL + '/Create';
export const ContactDetail_update = ContactDetailURL + '/Update';
export const ContactDetail_readById = ContactDetailURL + '/ReadById';
export const ContactDetail_readAll = ContactDetailURL + '/ReadAll';
export const ContactDetail_readByMasterId = ContactDetailURL + '/ReadByMasterId';
export const ContactDetail_delete = ContactDetailURL + '/Delete';
//#endregion

//#region Country API
export const CountryURL: string = NishwikMaster + '/C';
export const Country_create = CountryURL + '/Create';
export const Country_update = CountryURL + '/Update';
export const Country_readById = CountryURL + '/ReadById';
export const Country_readAll = CountryURL + '/ReadAll';
export const Country_delete = CountryURL + '/Delete';
//#endregion

//region MenuFeature API
export const MenuFeatureURL: string = NishwikMaster + '/MF';
export const createMenuFeature = MenuFeatureURL + '/Create'
export const updateMenuFeature = MenuFeatureURL + '/Update'
export const readAllMenuFeature = MenuFeatureURL + '/ReadAll'
export const readByIdMenuFeature = MenuFeatureURL + '/ReadById'
export const readByMenuIdFeature = MenuFeatureURL + '/ReadByMenuId'
export const readByProjectIdFeature = MenuFeatureURL + '/ReadByProjectId'
export const deleteMenuFeature = MenuFeatureURL + '/Delete'
//endregion

//region MenuMaster API
export const MenuMasterURL: string = NishwikMaster + '/MM';
export const MenuMaster_create = MenuMasterURL + '/Create';
export const MenuMaster_update = MenuMasterURL + '/Update';
export const MenuMaster_readById = MenuMasterURL + '/ReadById';
export const MenuMaster_delete = MenuMasterURL + '/Delete';
export const MenuMaster_readBySoftwareId = MenuMasterURL + '/ReadBySoftwareId';
export const MenuMaster_readByUserId = MenuMasterURL + '/ReadByUserId';
export const MenuMaster_readAll = MenuMasterURL + '/ReadAll';
//endregion

//region Roles API
export const RolesURL: string = NishwikMaster + '/R';
export const Roles_create = RolesURL + '/Create';
export const Roles_update = RolesURL + '/Update';
export const Roles_delete = RolesURL + '/Delete';
export const Roles_getDictionary = RolesURL + '/GetDictionary';
export const Roles_readAllPaginated = RolesURL + '/ReadAllPaginated';
export const Roles_readByGroupName = RolesURL + '/ReadByGroupName';
export const Roles_readByCompanyId = RolesURL + '/ReadByCompanyId';
//endregion

//region SoftwareMaster API
export const SoftwareMasterURL: string = NishwikMaster + '/SM';
export const SoftwareMaster_create = SoftwareMasterURL + '/Create';
export const SoftwareMaster_update = SoftwareMasterURL + '/Update';
export const SoftwareMaster_readById = SoftwareMasterURL + '/ReadById';
export const SoftwareMaster_readAll = SoftwareMasterURL + '/ReadAll';
export const SoftwareMaster_delete = SoftwareMasterURL + '/Delete';
export const SoftwareMaster_readByUserId = SoftwareMasterURL + '/ReadByUserId';
export const SoftwareMaster_GetDictionary = SoftwareMasterURL + '/GetDictionary'
//endregion

//region State API
export const StateURL: string = NishwikMaster + '/S';
export const State_create = StateURL + '/Create';
export const State_update = StateURL + '/Update';
export const State_readById = StateURL + '/ReadByID';
export const State_readAll = StateURL + '/ReadALL';
export const State_delete = StateURL + '/delete';
//endregion

//#region SubRoles API
export const SubRolesURL: string = NishwikMaster + '/SR';
export const SubRoles_create = SubRolesURL + '/Create';
export const SubRoles_update = SubRolesURL + '/Update';
export const SubRoles_readByUserId = SubRolesURL + '/ReadByUserId';
export const SubRoles_readByProjectId = SubRolesURL + '/ReadByProjectId';
export const SubRoles_readById = SubRolesURL + '/ReadById';
export const SubRoles_updateIsDefault = SubRolesURL + '/UpdateIsDefault';
export const SubRoles_delete = SubRolesURL + '/Delete';
export const SubRoles_readByRoleId = SubRolesURL + '/ReadByRoleId';

//#endregion

//region UserLogin API
export const UserLoginURL: string = NishwikMaster + '/UL';
export const UserLogin_create = UserLoginURL + '/Create';
export const UserLogin_update = UserLoginURL + '/Update';
export const UserLogin_delete = UserLoginURL + '/Delete';
export const UserLogin_readByUserId = UserLoginURL + '/ReadByUserId';
export const UserLogin_validateUserName = UserLoginURL + '/ValidateUserName';
export const UserLogin_auth = UserLoginURL + '/auth';
export const UserLogin_AzureAuth = UserLoginURL + '/AzureAuth';
export const UserLogin_validateToken = UserLoginURL + '/ValidateToken';
//endregion

//region UserMaster API
export const UserMasterURL: string = NishwikMaster + '/UM';
export const UserMaster_create = UserMasterURL + '/Create';
export const UserMaster_update = UserMasterURL + '/Update';
export const UserMaster_updateStatus = UserMasterURL + '/UpdateStatus';
export const UserMaster_readById = UserMasterURL + '/ReadById';
export const UserMaster_readAll = UserMasterURL + '/ReadAll';
export const UserMaster_readAllPaginated = UserMasterURL + '/ReadAllPaginated';
export const UserMaster_delete = UserMasterURL + '/Delete';
export const UserMaster_GetDictionary = UserMasterURL + '/GetDictionary';
export const UserMaster_SearchByName = UserMasterURL + '/SearchByName';
//endregion

//region UserPermission API
const UserPermissionURL: string = NishwikMaster + '/UP';
export const UserPermission_create = UserPermissionURL + '/Create';
export const UserPermission_update = UserPermissionURL + '/Update';
export const UserPermission_readAll = UserPermissionURL + '/ReadAll';
export const UserPermission_readByFeatureId = UserPermissionURL + '/ReadByFeatureId';
export const UserPermission_readById = UserPermissionURL + '/ReadById';
export const UserPermission_readBySoftwareId = UserPermissionURL + '/ReadBySoftwareId';
export const UserPermission_readByUserId = UserPermissionURL + '/ReadByUserId';
export const UserPermission_readBySubRoleId = UserPermissionURL + '/ReadBySubRoleId';
export const UserPermission_delete = UserPermissionURL + '/Delete';
//endregion

//region UserRoles API
export const UserRolesURL: string = NishwikMaster + '/UR';
export const UserRoles_create = UserRolesURL + '/Create';
export const UserRoles_update = UserRolesURL + '/Update';
export const UserRoles_delete = UserRolesURL + '/Delete';
export const UserRoles_readByUserId = UserRolesURL + '/ReadByUserId';
export const UserRoles_readBySoftwareId = UserRolesURL + '/ReadBySoftwareId';
export const UserRoles_readAll = UserRolesURL + '/ReadAll';
//endregion


//region ValueList API
export const ValueListURL: string = NishwikMaster + '/VL';
export const ValueList_create = ValueListURL + '/Create';
export const ValueList_update = ValueListURL + '/Update';
export const ValueList_readById = ValueListURL + '/ReadById';
export const ValueList_readAll = ValueListURL + '/ReadAll';
export const ValueList_delete = ValueListURL + '/Delete';
export const ValueList_ReadKeyValueDictionaryByCode = ValueListURL + '/ReadKeyValueDictionaryByCode';
export const ValueList_GetFilteredKeyValueDictionaryByCode = ValueListURL + '/ReadFilteredKeyValueDictionaryByCode';
//endregion

//region ValueListItem API
export const ValueListItemURL: string = NishwikMaster + '/VLI';
export const ValueListItem_create = ValueListItemURL + '/Create';
export const ValueListItem_update = ValueListItemURL + '/Update';
export const ValueListItem_delete = ValueListItemURL + '/Delete';
export const ValueListItem_readById = ValueListItemURL + '/ReadById';
export const ValueListItem_readByValueListId = ValueListItemURL + '/ReadByValueListId';
export const ValueListItem_readByVlCode = ValueListItemURL + '/ReadByVlCode';
export const ValueListItem_readByVlName = ValueListItemURL + '/ReadByVlName';
export const ValueListItem_readByVlCodeList = ValueListItemURL + '/ReadByVlCodeList';
export const ValueListItem_readByCompanyId = ValueListItemURL + '/ReadByCompanyId';


//endregion

//region IndividualMaster API
export const IndividualMasterURL: string = NishwikMaster + '/IM';
export const IndividualMaster_create = IndividualMasterURL + '/Create';
export const IndividualMaster_update = IndividualMasterURL + '/Update';
export const IndividualMaster_delete = IndividualMasterURL + '/Delete';
export const IndividualMaster_readById = IndividualMasterURL + '/ReadById';
export const IndividualMaster_readAll = IndividualMasterURL + '/ReadAll';
export const IndividualMaster_readAllPaginated = IndividualMasterURL + '/ReadAllPaginated';
export const IndividualMaster_readByUserId = IndividualMasterURL + '/ReadByUserId';
export const IndividualMaster_searchByName = IndividualMasterURL + '/SearchByName';
//endregion


//region CompanyCategory API
export const CompanyCategoryURL: string = NishwikMaster + '/CCT';
export const CompanyCategory_create = CompanyCategoryURL + '/Create';
export const CompanyCategory_update = CompanyCategoryURL + '/Update';
export const CompanyCategory_delete = CompanyCategoryURL + '/Delete';
export const CompanyCategory_readById = CompanyCategoryURL + '/ReadById';
export const CompanyCategory_readAll = CompanyCategoryURL + '/ReadAll';
//endregion

//region CompanySubCategory API
export const CompanySubCategoryURL: string = NishwikMaster + '/CSC';
export const CompanySubCategory_create = CompanySubCategoryURL + '/Create';
export const CompanySubCategory_update = CompanySubCategoryURL + '/Update'
export const CompanySubCategory_delete = CompanySubCategoryURL + '/Delete'
export const CompanySubCategory_readById = CompanySubCategoryURL + '/ReadById';
export const CompanySubCategory_readByCategoryId = CompanySubCategoryURL + '/ReadByCategoryId'
export const CompanySubCategory_readAll = CompanySubCategoryURL + '/ReadAll';
//endregion


//region LeadMaster API
export const LeadMasterURL: string = CRM + '/LM'
export const LeadMaster_create = LeadMasterURL + '/Create';
export const LeadMaster_update = LeadMasterURL + '/Update';
export const LeadMaster_delete = LeadMasterURL + '/Delete';
export const LeadMaster_readById = LeadMasterURL + '/ReadById';
export const LeadMaster_readAll = LeadMasterURL + '/ReadAll';
export const LeadMaster_readByUserId = LeadMasterURL + '/ReadByUserId';
export const LeadMaster_forceClose = LeadMasterURL + '/ForceClose';
export const LeadMaster_TakeOver = LeadMasterURL + '/TakeOver';
export const LeadMaster_worklist = LeadMasterURL + '/WorkList';
export const LeadMaster_dayBook = LeadMasterURL + '/DayBook';
export const LeadMaster_getAdminDashBoard = LeadMasterURL + '/GetAdminDashboard';
export const LeadMaster_updateFollowUp = LeadMasterURL + '/UpdateFollowUp';
export const LeadMaster_WorkListCountSummary = LeadMasterURL + '/WorkListCountSummary';
export const LeadMaster_ReadByLeadOwner = LeadMasterURL + '/ReadByLeadOwner';
//endregion

//region LeadDetail API
export const LeadDetailURL: string = CRM + '/LD'
export const LeadDetail_create = LeadDetailURL + '/Create';
export const LeadDetail_update = LeadDetailURL + '/Update';
export const LeadDetail_delete = LeadDetailURL + '/Delete';
export const LeadDetail_readById = LeadDetailURL + '/ReadById';
export const LeadDetail_readAll = LeadDetailURL + '/ReadAll';
export const LeadDetail_readByLeadId = LeadDetailURL + '/ReadByLeadId';

//endregion


//region LeadAssignee API
export const LeadAssigneeURL: string = CRM + '/LAG'
export const LeadAssignee_create = LeadAssigneeURL + '/Create';
export const LeadAssignee_update = LeadAssigneeURL + '/Update';
export const LeadAssignee_delete = LeadAssigneeURL + '/Delete';
export const LeadAssignee_readById = LeadAssigneeURL + '/ReadById';
export const LeadAssignee_readAll = LeadAssigneeURL + '/ReadAll';
export const LeadAssignee_readByLeadId = LeadAssigneeURL + '/ReadByLeadId';
//endregion

//region LeadActivity API
export const LeadActivityURL: string = CRM + '/LA'
export const LeadActivity_create = LeadActivityURL + '/Create';
export const LeadActivity_update = LeadActivityURL + '/Update';
export const LeadActivity_delete = LeadActivityURL + '/Delete';
export const LeadActivity_readById = LeadActivityURL + '/ReadById';
export const LeadActivity_readAll = LeadActivityURL + '/ReadAll';
export const LeadActivity_readByLeadId = LeadActivityURL + '/ReadByLeadId';
//endregion

//#region SupportTicket API
export const SupportTicket: string = SupportDesk + '/ST';
export const SupportTicket_create = SupportTicket + "/Create"
export const SupportTicket_update = SupportTicket + '/Update';
export const SupportTicket_readById = SupportTicket + '/ReadById';
export const SupportTicket_readAll = SupportTicket + '/ReadAll';
export const SupportTicket_readByTicketOwner = SupportTicket + '/ReadByTicketOwner';
export const SupportTicket_delete = SupportTicket + '/Delete';
export const SupportTicket_forceClose = SupportTicket + '/ForceClose';
export const SupportTicket_reOpen = SupportTicket + '/ReOpen';
export const SupportTicket_takeOver = SupportTicket + '/TakeOver';
export const SupportTicket_ticketWorkList = SupportTicket + '/WorkList';
export const SupportTicket_GetAdminDashboard = SupportTicket + '/GetAdminDashboard';
//#endregion


//region TicketActivity API
export const TicketActivityURL: string = SupportDesk + '/TA'
export const TicketActivity_create = TicketActivityURL + '/Create';
export const TicketActivity_update = TicketActivityURL + '/Update';
export const TicketActivity_delete = TicketActivityURL + '/Delete';
export const TicketActivity_readById = TicketActivityURL + '/ReadById';
export const TicketActivity_readAll = TicketActivityURL + '/ReadAll';
export const TicketActivity_readByTicketId = TicketActivityURL + '/ReadByTicketId';
//endregion

//region TicketAssignee API
export const TicketAssigneeURL: string = SupportDesk + '/TAG'
export const TicketAssignee_create = TicketAssigneeURL + '/Create';
export const TicketAssignee_update = TicketAssigneeURL + '/Update';
export const TicketAssignee_delete = TicketAssigneeURL + '/Delete';
export const TicketAssignee_readById = TicketAssigneeURL + '/ReadById';
export const TicketAssignee_readAll = TicketAssigneeURL + '/ReadAll';
export const TicketAssignee_readByTicketId = TicketAssigneeURL + '/ReadByTicketId';
export const TicketAssignee_updateStatus = TicketAssigneeURL + '/UpdateStatus';
//endregion




//#region SupportProjectMaster API
export const SupportProjectMaster: string = SupportDesk + '/SPM';
export const SupportProjectMaster_create = SupportProjectMaster + "/Create";
export const SupportProjectMaster_update = SupportProjectMaster + '/Update';
export const SupportProjectMaster_readById = SupportProjectMaster + '/ReadById';
export const SupportProjectMaster_readAll = SupportProjectMaster + '/ReadAll';
export const SupportProjectMaster_delete = SupportProjectMaster + '/Delete';
export const SupportProjectMaster_readByCompanyId = SupportProjectMaster + '/ReadByCompanyId'
export const SupportProjectMaster_readAllPaginated = SupportProjectMaster + '/ReadAllPaginated'
//#endregion

//#region UserBranchSoftwareMapping
export const UserBranchSoftwareMapping: string = NishwikMaster + '/UBSM'
export const UserBranchSoftwareMapping_create = UserBranchSoftwareMapping + '/Create';
export const UserBranchSoftwareMapping_update = UserBranchSoftwareMapping + '/Update';
export const UserBranchSoftwareMapping_readById = UserBranchSoftwareMapping + '/ReadById';
export const UserBranchSoftwareMapping_readByUserId = UserBranchSoftwareMapping + '/ReadByUserId';
export const UserBranchSoftwareMapping_readAll = UserBranchSoftwareMapping + '/ReadAll';
export const UserBranchSoftwareMapping_delete = UserBranchSoftwareMapping + '/Delete';
//#endregion


//#region DocumentMaster
export const DocumentMasterURL: string = NishwikMaster + '/DM'
export const DocumentMaster_Upload = DocumentMasterURL + '/Upload';
//#endregion

//#region HRMS Attendance
export const HRMS_Attendance: string = HRMS + '/AT'
export const HRMS_Attendance_create = HRMS_Attendance + '/Create';
export const HRMS_Attendance_update = HRMS_Attendance + '/Update';
export const HRMS_Attendance_readById = HRMS_Attendance + '/ReadById';
export const HRMS_Attendance_readAll = HRMS_Attendance + '/ReadAll';
export const HRMS_Attendance_delete = HRMS_Attendance + '/Delete';
export const HRMS_Attendance_readByUserMonth = HRMS_Attendance + '/ReadByUserMonth';
export const HRMS_Attendance_readByIndIdByDate = HRMS_Attendance + '/ReadByIndividualIdByDate';
export const HRMS_Attendance_CheckInCheckOut = HRMS_Attendance + '/CheckInCheckOut';
export const HRMS_Attendance_CheckInCheckOutByCode =
  'https://dev.apig.nishwik.com/HRMS/AT/CheckInCheckOutByCode';
export const HRMS_Attendance_ReadAllPaginatedByDate = HRMS_Attendance + '/ReadAllPaginatedByDate';
export const HRMS_Attendance_GetMonthlyAttendanceMuster = HRMS_Attendance + '/GetMonthlyAttendanceMuster';
export const HRMS_Attendance_GetMonthlyAttendanceMusterPaginated = HRMS_Attendance + '/GetMonthlyAttendanceMusterPaginated';
//#endregion

//#region OPCalendar
export const OPCalendar: string = NishwikMaster + '/OPC'
export const OPCalendar_create = OPCalendar + '/Create';
export const OPCalendar_update = OPCalendar + '/Update';
export const OPCalendar_readAll = OPCalendar + '/ReadAll';
export const OPCalendar_delete = OPCalendar + '/Delete';
export const OPCalendar_readByCompanyID = OPCalendar + '/ReadByCompanyId';
export const OPCalendar_getMonthlyCalendarByCompany = OPCalendar + '/GetMonthlyCalendarByCompany';
export const OPCalendar_getYearlyWeekendAndHolidayListByCompany = OPCalendar + '/GetYearlyWeekendAndHolidayListByCompany';
export const OPCalendar_GetUpcomingHolidays = OPCalendar + '/GetUpcomingHolidays';
//#endregion

//#region HRMS Regularization
export const HRMS_Regularization: string = HRMS + '/RG'
export const HRMS_Regularization_create = HRMS_Regularization + '/Create';
export const HRMS_Regularization_update = HRMS_Regularization + '/Update';
export const HRMS_Regularization_readById = HRMS_Regularization + '/ReadById';
export const HRMS_Regularization_readAll = HRMS_Regularization + '/ReadAll';
export const HRMS_Regularization_delete = HRMS_Regularization + '/Delete';
export const HRMS_Regularization_readByIndId = HRMS_Regularization + '/ReadByIndId';
export const HRMS_Regularization_readByManagerId = HRMS_Regularization + '/ReadByManagerId'
export const HRMS_Regularization_readByManagerIdPaginated = HRMS_Regularization + '/ReadByManagerIdPaginated'
export const HRMS_Regularization_updateStatusByManager = HRMS_Regularization + '/UpdateStatusByManager'
export const HRMS_Regularization_GetRequestCountForManager = HRMS_Regularization + '/GetRequestCountForManager'
//#endregion

//#region MeetingMaster API
export const MeetingMaster: string = CRM + '/MM'
export const MeetingMaster_create = MeetingMaster + '/Create'
export const MeetingMaster_update = MeetingMaster + '/Update'
export const MeetingMaster_delete = MeetingMaster + '/Delete'
export const MeetingMaster_readById = MeetingMaster + '/ReadById'
export const MeetingMaster_readAll = MeetingMaster + '/ReadAll'
export const MeetingMaster_readByLeadId = MeetingMaster + '/ReadByLeadId'
export const MeetingMaster_readByCompnayId = MeetingMaster + '/ReadByCompanyId'
//#endregion

//#region MeetingDetail API
export const MeetingDetail: String = CRM + '/MD'
export const MeetingDetail_create = MeetingDetail + '/Create'
export const MeetingDetail_update = MeetingDetail + '/Update'
export const MeetingDetail_delete = MeetingDetail + '/Delete'
export const MeetingDetail_readbyId = MeetingDetail + '/ReadById'
export const MeetingDetail_readall = MeetingDetail + '/ReadAll'
export const MeetingDetail_createBulk = MeetingDetail + '/CreateBulk'
export const MeetingDetail_readbyMeetingId = MeetingDetail + '/ReadByMeetingId'
//#endregion

//region IndividualRelationMaster API
export const IndividualRelationURL: string = NishwikMaster + '/IR';
export const IndividualRelation_create = IndividualRelationURL + '/Create';
export const IndividualRelation_update = IndividualRelationURL + '/Update';
export const IndividualRelation_delete = IndividualRelationURL + '/Delete';
export const IndividualRelation_readById = IndividualRelationURL + '/ReadById';
export const IndividualRelation_readByIndId = IndividualRelationURL + '/ReadByIndividualId';
export const IndividualRelation_readAll = IndividualRelationURL + '/ReadAll';
//endregion


//#region ERP APIs API






//#region ERP Products API
export const Products: string = ERP + '/Prod'






//#region ItemMaster API
export const ItemMaster: string = Products + '/IM'
export const ItemMaster_Create = ItemMaster + '/Create'
export const ItemMaster_CreateBulkViaExcel = ItemMaster + '/CreateBulkViaExcel'
export const ItemMaster_CreateBulk = ItemMaster + '/CreateBulk'
export const ItemMaster_Update = ItemMaster + '/Update'
export const ItemMaster_Delete = ItemMaster + '/Delete'
export const ItemMaster_ReadbyId = ItemMaster + '/ReadById'
export const ItemMaster_ReadAll = ItemMaster + '/ReadAll'
export const ItemMaster_ReadAllPaginated = ItemMaster + '/ReadAllPaginated'
export const ItemMaster_UpdateBulkColumn = ItemMaster + '/UpdateBulkColumn'
export const ItemMaster_SearchByName = ItemMaster +'/SearchByName'
//#endregion

//#region ItemImage API
export const ItemImages: string = Products + '/II'
export const ItemImages_Create = ItemImages + '/Create'
export const ItemImages_Update = ItemImages + '/Update'
export const ItemImages_Delete = ItemImages + '/Delete'
export const ItemImages_ReadById = ItemImages + '/ReadById'
export const ItemImages_ReadByMasterId = ItemImages + '/ReadByMasterId'
export const ItemImages_ReadAll = ItemImages + '/ReadAll'
export const ItemImages_ReadAllPaginated = ItemImages + '/ReadAllPaginated'
//#endregion

//#region ItemPrice API
export const ItemPrice: string = Products + '/IP'
export const ItemPrice_create = ItemPrice + '/Create'
export const ItemPrice_Update = ItemPrice + '/Update'
export const ItemPrice_delete = ItemPrice + '/Delete'
export const ItemPrice_readbyId = ItemPrice + '/ReadById'
export const ItemPrice_readAll = ItemPrice + '/ReadAll'
export const ItemPrice_ReadByItemId = ItemPrice + '/ReadByItemId'

//#endregion


//#region ItemMasterUIC API
const ItemMasterUIC: string = Products + '/IMUIC';

export const ItemMasterUIC_Create = ItemMasterUIC + '/Create';
export const ItemMasterUIC_Update = ItemMasterUIC + '/Update';
export const ItemMasterUIC_Delete = ItemMasterUIC + '/Delete';
export const ItemMasterUIC_ReadByBranchId = ItemMasterUIC + '/ReadByBranchId';
export const ItemMasterUIC_ReadById = ItemMasterUIC + '/ReadById';
export const ItemMasterUIC_ReadAll = ItemMasterUIC + '/ReadAll';
//#endregion


//#region HRMS Designation
export const HRMS_Designations: string = HRMS + '/DSG'
export const HRMS_Designations_create = HRMS_Designations + '/Create';
export const HRMS_Designations_update = HRMS_Designations + '/Update';
export const HRMS_Designations_delete = HRMS_Designations + '/Delete';
export const HRMS_Designations_readAll = HRMS_Designations + '/ReadAll';
export const HRMS_Designations_readById = HRMS_Designations + '/ReadById';
export const HRMS_Designations_readAllPaginated = HRMS_Designations + '/ReadAllPaginated';
export const HRMS_Designations_readByCompanyId = HRMS_Designations + '/ReadByCompanyId';
export const HRMS_Designations_GetDictionary = HRMS_Designations + '/GetDictionary';
//#endregion

//#region HRMS InterviewMaster
export const InterviewMaster: string = HRMS + '/IM';
export const InterviewMaster_create = InterviewMaster + '/Create';
export const InterviewMaster_update = InterviewMaster + '/Update';
export const InterviewMaster_delete = InterviewMaster + '/Delete';
export const InterviewMaster_readById = InterviewMaster + '/ReadById';
export const InterviewMaster_readByIndId = InterviewMaster + '/ReadByIndId';
export const InterviewMaster_readAll = InterviewMaster + '/ReadAll';
export const InterviewMaster_readAllPaginated = InterviewMaster + '/ReadAllPaginated';


//#region HRMS InterviewDetail
export const InterviewDetail: string = HRMS + '/ID';

export const InterviewDetail_create = InterviewDetail + '/Create';
export const InterviewDetail_update = InterviewDetail + '/Update';
export const InterviewDetail_delete = InterviewDetail + '/Delete';
export const InterviewDetail_readById = InterviewDetail + '/ReadById';
export const InterviewDetail_readByInterviewId = InterviewDetail + '/ReadByInterviewId';
export const InterviewDetail_readAll = InterviewDetail + '/ReadAll';
//#endregion


//region AlertServiceMaster API
export const AlertServiceMasterURL: string = Notification + '/ASM';
export const AlertServiceMaster_create = AlertServiceMasterURL + '/Create';
export const AlertServiceMaster_update = AlertServiceMasterURL + '/Update';
export const AlertServiceMaster_delete = AlertServiceMasterURL + '/Delete';
export const AlertServiceMaster_readById = AlertServiceMasterURL + '/ReadById';
export const AlertServiceMaster_readAll = AlertServiceMasterURL + '/ReadAll';
export const AlertServiceMaster_ReadAllPaginated = AlertServiceMasterURL + '/ReadAllPaginated';
export const AlertServiceMaster_UpdateStatus = AlertServiceMasterURL + '/UpdateStatus';
//endregion

//region EmailConfig API
export const EmailConfig: string = Notification + '/EC';
export const EmailConfig_create = EmailConfig + '/Create';
export const EmailConfig_update = EmailConfig + '/Update';
export const EmailConfig_delete = EmailConfig + '/Delete';
export const EmailConfig_readById = EmailConfig + '/ReadById';
export const EmailConfig_readAll = EmailConfig + '/ReadAll';
export const EmailConfig_ReadAllPaginated = EmailConfig + '/ReadAllPaginated';
export const EmailConfig_updatePassword = EmailConfig + '/UpdatePassword'
//endregion

//region WhatsAppConfig API
export const WhatsAppConfigURL: string = Notification + '/WAC';
export const WhatsAppConfig_create = WhatsAppConfigURL + '/Create';
export const WhatsAppConfig_update = WhatsAppConfigURL + '/Update';
export const WhatsAppConfig_delete = WhatsAppConfigURL + '/Delete';
export const WhatsAppConfig_readById = WhatsAppConfigURL + '/ReadById';
export const WhatsAppConfig_readAll = WhatsAppConfigURL + '/ReadAll';
export const WhatsAppConfig_readAllPaginated = WhatsAppConfigURL + '/ReadAllPaginated';
//endregion

//region DBConfig API
export const DBConfigURL: string = Notification + '/DBCM';
export const DBConfig_create = DBConfigURL + '/Create';
export const DBConfig_update = DBConfigURL + '/Update';
export const DBConfig_delete = DBConfigURL + '/Delete';
export const DBConfig_readById = DBConfigURL + '/ReadById';
export const DBConfig_readAll = DBConfigURL + '/ReadAll';
export const DBConfig_readAllPaginated = DBConfigURL + '/ReadAllPaginated';
export const DBConfig_updatePassword = DBConfigURL + '/UpdatePassword';
//endregion

//region SmsConfig API
export const SmsConfig: string = Notification + '/SMS';
export const SmsConfig_create = SmsConfig + '/Create';
export const SmsConfig_update = SmsConfig + '/Update';
export const SmsConfig_delete = SmsConfig + '/Delete';
export const SmsConfig_readById = SmsConfig + '/ReadById';
export const SmsConfig_readAll = SmsConfig + '/ReadAll';
export const SmsConfig_readAllPaginated = SmsConfig + '/ReadAllPaginated';
export const SmsConfig_readByCompanyId = SmsConfig + '/ReadByCompanyId';
export const SmsConfig_readByRequest = SmsConfig + '/ReadByRequest';
//endregion


//region AlertsSchedular API
export const AlertsSchedularURL: string = Notification + '/AS';
export const AlertsSchedular_create = AlertsSchedularURL + '/Create';
export const AlertsSchedular_update = AlertsSchedularURL + '/Update';
export const AlertsSchedular_delete = AlertsSchedularURL + '/Delete';
export const AlertsSchedular_readById = AlertsSchedularURL + '/ReadById';
export const AlertsSchedular_readAll = AlertsSchedularURL + '/ReadAll';
export const AlertsSchedular_readAllPaginated = AlertsSchedularURL + '/ReadAllPaginated';
//endregion

//region AlertServiceMaster API
export const AlertsServiceVariablesURL: string = Notification + '/ASV';
export const AlertsServiceVariables_create = AlertsServiceVariablesURL + '/Create';
export const AlertsServiceVariables_update = AlertsServiceVariablesURL + '/Update';
export const AlertsServiceVariables_delete = AlertsServiceVariablesURL + '/Delete';
export const AlertsServiceVariables_readById = AlertsServiceVariablesURL + '/ReadById';
export const AlertsServiceVariables_readAll = AlertsServiceVariablesURL + '/ReadAll';
export const AlertsServiceVariables_ReadAllByServiceId = AlertsServiceVariablesURL + '/ReadAllByServiceId'
//endregion

//region AlertServiceMaster API
export const AlertsServiceSchedularURL: string = Notification + '/ASS';
export const AlertsServiceSchedular_create = AlertsServiceSchedularURL + '/Create';
export const AlertsServiceSchedular_update = AlertsServiceSchedularURL + '/Update';
export const AlertsServiceSchedular_delete = AlertsServiceSchedularURL + '/Delete';
export const AlertsServiceSchedular_readById = AlertsServiceSchedularURL + '/ReadById';
export const AlertsServiceSchedular_readAll = AlertsServiceSchedularURL + '/ReadAll';
export const AlertsServiceSchedular_readByServiceId = AlertsServiceSchedularURL + '/ReadByServiceId'
//endregion

//region NotificationMaster API
export const NotificationMasterURL: string = Notification + '/NM';
export const notificationMaster_readAllPaginated = NotificationMasterURL + '/ReadAllPaginated';
export const notificationMaster_Create = NotificationMasterURL + '/Create';
export const notificationMaster_UpdateStatusById = NotificationMasterURL + '/UpdateStatusById';
//endregion


//region Customer List API

export const CustomerListUIC: string = Master + '/CLUIC';

export const CustomerListUIC_Create = CustomerListUIC + '/Create';
export const CustomerListUIC_Update = CustomerListUIC + '/Update';
export const CustomerListUIC_Delete = CustomerListUIC + '/Delete';
export const CustomerListUIC_ReadByCompanyId = CustomerListUIC + '/ReadByCompanyId';
export const CustomerListUIC_ReadById = CustomerListUIC + '/ReadById';
export const CustomerListUIC_ReadAll = CustomerListUIC + '/ReadAll';


export const CustomerData_ReadAll = CustomerListUIC + 'DataReadAll'
export const CustomerData_ReadAllPaginated = CustomerListUIC + '/ReadAllPaginated'
//endregion



//region Customer Form API
export const CustomerFormUIC: string = Master + '/CUIC';

export const CustomerFormUIC_Create = CustomerFormUIC + '/Create';
export const CustomerFormUIC_Update = CustomerFormUIC + '/Update';
export const CustomerFormUIC_Delete = CustomerFormUIC + '/Delete';
export const CustomerFormUIC_ReadByCompanyId = CustomerFormUIC + '/ReadByCompanyId';
export const CustomerFormUIC_ReadById = CustomerFormUIC + '/ReadById';
export const CustomerFormUIC_ReadAll = CustomerFormUIC + '/ReadAll';
//endregion

//region Supplier List API
export const SupplierListUIC: string = Master + '/SLUIC';

export const SupplierListUIC_Create = SupplierListUIC + '/Create';
export const SupplierListUIC_Update = SupplierListUIC + '/Update';
export const SupplierListUIC_Delete = SupplierListUIC + '/Delete';
export const SupplierListUIC_ReadByCompanyId = SupplierListUIC + '/ReadByCompanyId';
export const SupplierListUIC_ReadById = SupplierListUIC + '/ReadById';
export const SupplierListUIC_ReadAll = SupplierListUIC + '/ReadAll';


export const SupplierData_ReadAll = SupplierListUIC + 'DataReadAll'
export const SupplierData_ReadAllPaginated = SupplierListUIC + '/ReadAllPaginated'
//endregion


//region Support Form API
export const SupplierFormUIC: string = Master + '/SUIC';

export const SupplierFormUIC_Create = SupplierFormUIC + '/Create';
export const SupplierFormUIC_Update = SupplierFormUIC + '/Update';
export const SupplierFormUIC_Delete = SupplierFormUIC + '/Delete';
export const SupplierFormUIC_ReadByCompanyId = SupplierFormUIC + '/ReadByCompanyId';
export const SupplierFormUIC_ReadById = SupplierFormUIC + '/ReadById';
export const SupplierFormUIC_ReadAll = SupplierFormUIC + '/ReadAll';
//endregion

//region Vendor List API
export const VendorListUIC: string = Master + '/VLUIC';
export const VendorListUIC_Create = VendorListUIC + '/Create';
export const VendorListUIC_Update = VendorListUIC + '/Update';
export const VendorListUIC_Delete = VendorListUIC + '/Delete';
export const VendorListUIC_ReadByCompanyId = VendorListUIC + '/ReadByCompanyId';
export const VendorListUIC_ReadById = VendorListUIC + '/ReadById';
export const VendorListUIC_ReadAll = VendorListUIC + '/ReadAll';


export const VendorData_ReadAll = VendorListUIC + 'DataReadAll'
export const VendorData_ReadAllPaginated = VendorListUIC + '/ReadAllPaginated'
//endregion


//region Vendor Form API
export const VendorFormUIC: string = Master + '/VUIC';

export const VendorFormUIC_Create = VendorFormUIC + '/Create';
export const VendorFormUIC_Update = VendorFormUIC + '/Update';
export const VendorFormUIC_Delete = VendorFormUIC + '/Delete';
export const VendorFormUIC_ReadByCompanyId = VendorFormUIC + '/ReadByCompanyId';
export const VendorFormUIC_ReadById = VendorFormUIC + '/ReadById';
export const VendorFormUIC_ReadAll = VendorFormUIC + '/ReadAll';
//endregion


//region Generic List API
export const GenericListUIC: string = NishwikMaster + '/GLUIC';
export const GenericListUIC_Create = GenericListUIC + '/Create';
export const GenericListUIC_Update = GenericListUIC + '/Update';
export const GenericListUIC_Delete = GenericListUIC + '/Delete';
export const GenericListUIC_ReadByCompanyId = GenericListUIC + '/ReadByCompanyId';
export const GenericListUIC_ReadById = GenericListUIC + '/ReadById';
export const GenericListUIC_ReadAll = GenericListUIC + '/ReadAll';
export const GenericListUIC_ReadAllPaginated = GenericListUIC + '/ReadAllPaginated'
export const GenericListData_ReadAllPaginated = GenericListUIC + '/ReadDataPaginated'
export const GenericListData_ReadDataById = GenericListUIC + '/ReadDataById'
//endregion

//region Generic List API
export const GenericFormUIC: string = NishwikMaster + '/GFUIC';
export const GenericFormUIC_Create = GenericFormUIC + '/Create';
export const GenericFormUIC_Update = GenericFormUIC + '/Update';
export const GenericFormUIC_Delete = GenericFormUIC + '/Delete';
export const GenericFormUIC_ReadByCompanyId = GenericFormUIC + '/ReadByCompanyId';
export const GenericFormUIC_ReadById = GenericFormUIC + '/ReadById';
export const GenericFormUIC_ReadAll = GenericFormUIC + '/ReadAll';

//endregion

export const EmailMarketingDetail: string = CRM + '/EMD';
export const EmailMarketingDetail_Create = EmailMarketingDetail + '/Create';
export const EmailMarketingDetail_Update = EmailMarketingDetail + '/Update';
export const EmailMarketingDetail_Delete = EmailMarketingDetail + '/Delete';
export const EmailMarketingDetail_DeleteAll = EmailMarketingDetail + '/DeleteAll';
export const EmailMarketingDetail_ReadByCompanyId = EmailMarketingDetail + '/ReadByCompanyId';
export const EmailMarketingDetail_ReadById = EmailMarketingDetail + '/ReadById';
export const EmailMarketingDetail_ReadAll = EmailMarketingDetail + '/ReadAll'
export const EmailMarketingDetail_UploadBulkCheck = EmailMarketingDetail + '/UploadBulkCheck'
export const EmailMarketingDetail_UploadBulkExecute = EmailMarketingDetail + '/UploadBulkExecute'
export const EmailMarketingDetail_ReadByEmailGroup = EmailMarketingDetail + '/ReadByEmailGroup'
export const EmailMarketingDetail_GetEmailGroups = EmailMarketingDetail + '/GetEmailGroups'

//endregion

//#region HRMS Departments
export const HRMS_Departments: string = HRMS + '/DPT'
export const HRMS_Departments_create = HRMS_Departments + '/Create';
export const HRMS_Departments_update = HRMS_Departments + '/Update';
export const HRMS_Departments_delete = HRMS_Departments + '/Delete';
export const HRMS_Departments_readAll = HRMS_Departments + '/ReadAll';
export const HRMS_Departments_readById = HRMS_Departments + '/ReadById';
export const HRMS_Departments_readByCompanyId = HRMS_Departments + '/ReadByCompanyId';
export const HRMS_Departments_GetDictionary = HRMS_Departments + '/GetDictionary';
export const HRMS_Departments_readAllPaginated = HRMS_Departments + '/ReadAllPaginated';
//#endregion

//region IndividualHierarchy API
export const IndHierarchyURL: string = HRMS + '/IH';
export const IndHierarchy_create = IndHierarchyURL + '/Create';
export const IndHierarchy_update = IndHierarchyURL + '/Update';
export const IndHierarchy_delete = IndHierarchyURL + '/Delete';
export const IndHierarchy_readById = IndHierarchyURL + '/ReadById';
export const IndHierarchy_readAll = IndHierarchyURL + '/ReadAll';
export const IndHierarchy_readByIndId = IndHierarchyURL + '/ReadByIndId';
export const IndHierarchy_readByUserId = IndHierarchyURL + '/ReadByUserId';
export const IndHierarchy_GetManagerDictionary = IndHierarchyURL + '/GetManagerDictionary';
//endregion

//region Accounts API
export const Accounts: string = ERP + '/ACCT/ACC';
export const Accounts_Create = Accounts + '/Create';
export const Accounts_Update = Accounts + '/Update';
export const Accounts_Delete = Accounts + '/Delete';
export const Accounts_ReadById = Accounts + '/ReadById';
export const Accounts_ReadAll = Accounts + '/ReadAll'
//endregion


//region AmcMaster API
export const AmcMasterURL : string = Billing +'/AM' ;
export const AmcMaster_Create      = AmcMasterURL +'/Create' ;
export const AmcMaster_Update      = AmcMasterURL +'/Update' ;
export const AmcMaster_Delete      = AmcMasterURL +'/Delete' ;
export const AmcMaster_ReadById    = AmcMasterURL +'/ReadById' ;
export const AmcMaster_ReadByCompanyId = AmcMasterURL +'/ReadByCompanyId' ;
export const AmcMaster_ReadByClienId = AmcMasterURL +'/ReadByClientId' ;
export const AmcMaster_ReadAll       = AmcMasterURL +'/ReadAll' ;
//endregion

//region AmcDetail API
export const AmcDetailURL : string   = Billing + '/AD';
export const AmcDetail_Create        = AmcDetailURL + '/Create';
export const AmcDetail_Update        = AmcDetailURL + '/Update';
export const AmcDetail_Delete        = AmcDetailURL + '/Delete';
export const AmcDetail_ReadById      = AmcDetailURL + '/ReadById';
export const AmcDetail_ReadAll       = AmcDetailURL + '/ReadAll';
export const AmcDetail_ReadByAmcId   = AmcDetailURL + '/ReadByAmcId';
export const AmcDetail_ReadByItemId  = AmcDetailURL + '/ReadByItemId';
//endregion

//region Vouchers API
export const Vouchers: string = ERP + '/ACCT/VOC';
export const Vouchers_Create = Vouchers + '/Create';
export const Vouchers_Update = Vouchers + '/Update';
export const Vouchers_Delete = Vouchers + '/Delete';
export const Vouchers_ReadById = Vouchers + '/ReadById';
export const Vouchers_ReadAll = Vouchers + '/ReadAll'
//endregion


//region Bank Detail APIs
export const BankDetail: string = NishwikMaster + '/BD';
export const BankDetail_Create = BankDetail + '/Create';
export const BankDetail_Update = BankDetail + '/Update';
export const BankDetail_Delete = BankDetail + '/Delete';
export const BankDetail_ReadById = BankDetail + '/ReadById';
export const BankDetail_ReadAll = BankDetail + '/ReadAll'
export const BankDetail_GetBankName = BankDetail + '/GetBankName'
export const BankDetail_GetBranchName = BankDetail + '/GetBranchName'
export const BankDetail_ReadByMasterId = BankDetail + '/ReadByMasterId';
//endregion

//region QuotationMaster API
export const QuotationMasterURL: string = CRM + '/QM'
export const QuotationMaster_create = QuotationMasterURL + '/Create';
export const QuotationMaster_update = QuotationMasterURL + '/Update';
export const QuotationMaster_delete = QuotationMasterURL + '/Delete';
export const QuotationMaster_readAll = QuotationMasterURL + '/ReadAll';
export const QuotationMaster_readById = QuotationMasterURL + '/ReadById';
export const QuotationMaster_readByCompanyId = QuotationMasterURL + '/ReadByCompanyId';
export const QuotationMaster_CloneAndCreate = QuotationMasterURL + '/CloneAndCreate';
export const QuotationMaster_SearchByQuotationNumber = QuotationMasterURL + '/SearchByQuotationNumber';
//endregion


//region QuotationMasterOtherDetails API
export const QuotationOtherChargesMasterURL: string = CRM + '/QOC'
export const QuotationOtherDetail_create = QuotationOtherChargesMasterURL + '/Create';
export const QuotationOtherDetail_update = QuotationOtherChargesMasterURL + '/Update';
export const QuotationOtherDetail_delete = QuotationOtherChargesMasterURL + '/Delete';
export const QuotationOtherDetail_readById = QuotationOtherChargesMasterURL + '/ReadById';
export const QuotationOtherDetail_readByQuotationId = QuotationOtherChargesMasterURL + '/ReadByQuotationId';
export const QuotationOtherDetail_readAll = QuotationOtherChargesMasterURL + '/ReadAll';
//endregion


//region HRMS LeaveTypes APIs
export const HRMS_LeaveTypes: string = HRMS + '/LT';
export const HRMS_LeaveTypes_Create: string = HRMS_LeaveTypes + '/Create';
export const HRMS_LeaveTypes_Update: string = HRMS_LeaveTypes + '/Update';
export const HRMS_LeaveTypes_Delete: string = HRMS_LeaveTypes + '/Delete';
export const HRMS_LeaveTypes_ReadAll: string = HRMS_LeaveTypes + '/ReadAll';
export const HRMS_LeaveTypes_ReadById: string = HRMS_LeaveTypes + '/ReadByID';
export const HRMS_LeaveTypes_ReadByCompanyID: string = HRMS_LeaveTypes + '/ReadByCompanyId';
//endregion

//region HRMS LeaveApplications APIs
export const HRMS_LeaveApplications: string = HRMS + '/LA';
export const HRMS_LeaveApplications_Create: string = HRMS_LeaveApplications + '/Create';
export const HRMS_LeaveApplications_Update: string = HRMS_LeaveApplications + '/Update';
export const HRMS_LeaveApplications_Delete: string = HRMS_LeaveApplications + '/Delete';
export const HRMS_LeaveApplications_ReadById: string = HRMS_LeaveApplications + '/ReadById';
export const HRMS_LeaveApplications_ReadAll: string = HRMS_LeaveApplications + '/ReadAll'
export const HRMS_LeaveApplications_ReadByIndId: string = HRMS_LeaveApplications + '/ReadByIndId';
export const HRMS_LeaveApplications_ReadBalanceByIndId: string = HRMS_LeaveApplications + '/ReadBalanceByIndId';
//region Voucher Entries APIs
export const VoucherEntries: string = ERP + '/ACCT/VOCE';
export const VoucherEntries_Create = VoucherEntries + '/Create';
export const VoucherEntries_Update = VoucherEntries + '/Update';
export const VoucherEntries_Delete = VoucherEntries + '/Delete';
export const VoucherEntries_ReadById = VoucherEntries + '/ReadById';
export const VoucherEntries_ReadByVoucherId = VoucherEntries + '/ReadByVoucherId'
export const VoucherEntries_ReadAll = VoucherEntries + '/ReadAll';
export const VoucherEntriesBulk_Create = VoucherEntries + '/CreateBulk'
//endregion

//region AccountingReports API
export const AccountReports: string = ERP + '/ACCT/ACR';
export const GetBalanceSheet = AccountReports + '/GetBalanceSheet';
export const GetDayBook = AccountReports + '/GetDayBook';
export const GetLedgerReport = AccountReports + '/GetLedgerReport';
export const GetProfitAndLoss = AccountReports + '/GetProfitAndLoss';
export const GetTrialBalance = AccountReports + '/GetTrialBalanceByGroup'
//endregion

//region QuotationDetail API
export const QuotationDetailURL: string = CRM + '/QD'
export const QuotationDetail_create = QuotationDetailURL + '/Create';
export const QuotationDetail_update = QuotationDetailURL + '/Update';
export const QuotationDetail_delete = QuotationDetailURL + '/Delete';
export const QuotationDetail_readAll = QuotationDetailURL + '/ReadAll';
export const QuotationDetail_readById = QuotationDetailURL + '/ReadById';
export const QuotationDetail_readByQuotationId = QuotationDetailURL + '/ReadByQuotationId';
//endregion

//region PurchaseMaster API
export const PurchaseMasterURL: string = Billing + '/PM';
export const PurchaseMaster_Create = PurchaseMasterURL + '/Create';
export const PurchaseMaster_Update = PurchaseMasterURL + '/Update';
export const PurchaseMaster_Delete = PurchaseMasterURL + '/Delete';
export const PurchaseMaster_ReadAll = PurchaseMasterURL + '/ReadAll';
export const PurchaseMaster_ReadById = PurchaseMasterURL + '/ReadById';
export const PurchaseMaster_ReadByCompanyId = PurchaseMasterURL + '/ReadByCompanyId'
export const PurchaseMaster_ReadByOrderId = PurchaseMasterURL + '/ReadByOrderId';
export const PurchaseMaster_SearchByInvoiceNo = PurchaseMasterURL + '/SearchByInvoiceNo';
export const PurchaseMaster_ReadBySupplierCompanyId = PurchaseMasterURL + '/ReadBySupplierCompanyId';
//endregion

//region SalesMaster API
export const SalesMasterURL: string = Billing + '/SM';
export const SalesMaster_Create = SalesMasterURL + '/Create';
export const SalesMaster_Update = SalesMasterURL + '/Update';
export const SalesMaster_Delete = SalesMasterURL + '/Delete';
export const SalesMaster_ReadById = SalesMasterURL + '/ReadById';
export const SalesMaster_ReadByMasterId = SalesMasterURL + '/ReadByMasterId';
export const SalesMaster_ReadAll = SalesMasterURL + '/ReadAll';
export const SalesMaster_ReadByOrderId = SalesMasterURL + '/ReadByOrderId';
export const SalesMaster_SearchByInvoiceNo = SalesMasterURL + '/SearchByInvoiceNo';
export const SalesMaster_ReadByProjectId = SalesMasterURL + '/ReadByProjectId';
export const SalesMaster_ReadByBilledCompanyId = SalesMasterURL + '/ReadByBilledCompanyId';
export const SalesMaster_CloneAndCreate = SalesMasterURL + '/CloneAndCreate';
//endregion

//region SalesDetail API
export const SalesDetailURL: string = Billing + '/SD';
export const SalesDetail_Create = SalesDetailURL + '/Create';
export const SalesDetail_Update = SalesDetailURL + '/Update';
export const SalesDetail_Delete = SalesDetailURL + '/Delete';
export const SalesDetail_ReadyById = SalesDetailURL + '/ReadById';
export const SalesDetail_ReadAll = SalesDetailURL + '/ReadAll';
export const SalesDetail_ReadByInvoiceId = SalesDetailURL + '/ReadByInvoiceId';
export const SalesDetail_ReadByItemId = SalesDetailURL + '/ReadByItemId';
export const SalesDetail_ReadByInvoiceIdForImport = SalesDetailURL + '/ReadByInvoiceIdForImport';
//endregion

//region PurchaseDetail API
export const PurchaseDetailURL: string = Billing + '/PD';
export const PurchaseDetail_Create = PurchaseDetailURL + '/Create';
export const PurchaseDetail_Update = PurchaseDetailURL + '/Update';
export const PurchaseDetail_Delete = PurchaseDetailURL + '/Delete';
export const PurchaseDetail_ReadAll = PurchaseDetailURL + '/ReadAll';
export const PurchaseDetail_ReadById = PurchaseDetailURL + '/ReadById';
export const PurchaseDetail_ReadByInvoiceId = PurchaseDetailURL + '/ReadByInvoiceId'
export const PurchaseDetail_ReadByItemId = PurchaseDetailURL + '/ReadByItemId';
export const PurchaseDetail_ReadByInvoiceIdForImport = PurchaseDetailURL + '/ReadByInvoiceIdForImport';
//endregion

//region SalesRelease API 
export const SalesReleaseURL: string = Billing + '/SR';
export const SalesRelease_Create = SalesReleaseURL + '/Create';
export const SalesRelease_Update = SalesReleaseURL + '/Update';
export const SalesRelease_Delete = SalesReleaseURL + '/Delete';
export const SalesRelease_ReadAll = SalesReleaseURL + '/ReadAll';
export const SalesRelease_ReadById = SalesReleaseURL + '/ReadById';
export const SalesRelease_ReadByCompanyId = SalesReleaseURL + '/ReadByCompanyId';
export const SalesRelease_SearchByReleaseNo = SalesReleaseURL + '/SearchByReleaseNo';
//endregion

//region SalesReleaseDetail API 
export const SalesReleaseDetailURL: string = Billing + '/SRD';
export const SalesReleaseDetail_Create = SalesReleaseDetailURL + '/Create';
export const SalesReleaseDetail_Update = SalesReleaseDetailURL + '/Update';
export const SalesReleaseDetail_Delete = SalesReleaseDetailURL + '/Delete';
export const SalesReleaseDetail_ReadAll = SalesReleaseDetailURL + '/ReadAll';
export const SalesReleaseDetail_ReadById = SalesReleaseDetailURL + '/ReadById';
export const SalesReleaseDetail_ReadByItemId = SalesReleaseDetailURL + '/ReadByItemId';
export const SalesReleaseDetail_ReadByReleaseId = SalesReleaseDetailURL + '/ReadByReleaseId';
export const SalesReleaseDetail_ReadByReleaseIdForImport = SalesReleaseDetailURL + '/ReadByReleaseIdForImport';
//endregion


//region PaymentMaster API
export const PaymentMasterURL : string = Billing + '/PMT'
export const PaymentsMaster_Create = PaymentMasterURL + '/Create'
export const PaymentsMaster_Update = PaymentMasterURL + '/Update'
export const PaymentsMaster_Delete = PaymentMasterURL + '/Delete'
export const PaymentsMaster_ReadById = PaymentMasterURL + '/ReadById'
export const PaymentsMaster_ReadAll = PaymentMasterURL + '/ReadAll'
export const PaymentsMaster_ReadByCompanyId = PaymentMasterURL + '/ReadByCompanyId'
export const PaymentsMaster_ReadByBilledCompanyId = PaymentMasterURL + '/ReadByBilledCompanyId'
//endregion

//region PaymentDetail API
export const PaymentDetailURL : string = Billing + '/PMTD'
export const PaymentsDetail_Create = PaymentDetailURL + '/Create'
export const PaymentsDetail_Update = PaymentDetailURL + '/Update'
export const PaymentsDetail_Delete = PaymentDetailURL + '/Delete'
export const PaymentsDetail_ReadById = PaymentDetailURL + '/ReadById'
export const PaymentsDetail_ReadAll = PaymentDetailURL + '/ReadAll'
export const PaymentsDetail_ReadByPaymentId = PaymentDetailURL + '/ReadByPaymentId'
export const PaymentsDetail_ReadByMasterId = PaymentDetailURL + '/ReadByMasterId'
export const PaymentsDetail_ReadByTransactionType =PaymentDetailURL +'/ReadByTransactionType'
//endregion

//#region PurchaseRelease API
export const PurchaseReleaseURL: string = Billing + '/PR'
export const PurchaseRelease_Create = PurchaseReleaseURL + '/Create'
export const PurchaseRelease_Update = PurchaseReleaseURL + '/Update'
export const PurchaseRelease_Delete = PurchaseReleaseURL + '/Delete'
export const PurchaseRelease_ReadbyId = PurchaseReleaseURL + '/ReadById'
export const PurchaseRelease_ReadAll = PurchaseReleaseURL + '/ReadAll'
export const PurchaseRelease_ReadByCompanyId = PurchaseReleaseURL + '/ReadByCompanyId'
export const PurchaseRelease_SearchByReleaseNo = PurchaseReleaseURL + '/SearchByReleaseNo'
//#endregion

//region PurchaseReleaseDetail API 
export const PurchaseReleaseDetailURL: string = Billing + '/PRD';
export const PurchaseReleaseDetail_Create = PurchaseReleaseDetailURL + '/Create';
export const PurchaseReleaseDetail_Update = PurchaseReleaseDetailURL + '/Update';
export const PurchaseReleaseDetail_Delete = PurchaseReleaseDetailURL + '/Delete';
export const PurchaseReleaseDetail_ReadAll = PurchaseReleaseDetailURL + '/ReadAll';
export const PurchaseReleaseDetail_ReadById = PurchaseReleaseDetailURL + '/ReadById';
export const PurchaseReleaseDetail_ReadByItemId = PurchaseReleaseDetailURL + '/ReadByItemId';
export const PurchaseReleaseDetail_ReadByReleaseId = PurchaseReleaseDetailURL + '/ReadByReleaseId';
export const PurchaseReleaseDetail_ReadByReleaseIdForImport = PurchaseReleaseDetailURL + '/ReadByReleaseIdForImport';
export const PurchaseReleaseDetail_ReadByInvoiceIdForImport = PurchaseReleaseDetailURL + '/ReadByInvoiceIdForImport';
//endregion


//region CreditnoteMaster API
export const CreditNoteMasterURL: string = Billing + '/CNM';
export const CreditNoteMaster_Create = CreditNoteMasterURL +'/Create';
export const  CreditNoteMaster_Update= CreditNoteMasterURL +'/Update';
export const  CreditNoteMaster_ReadById= CreditNoteMasterURL +'/ReadById';
export const  CreditNoteMaster_ReadByCompanyId= CreditNoteMasterURL +'/ReadByCompanyId';
export const  CreditNoteMaster_Delete= CreditNoteMasterURL +'/Delete';
//endregion


//region Debitnotemaster api
export const DebitNoteMasterURL: string=Billing + '/DNM';
export const DebitNoteMaster_Create=DebitNoteMasterURL +'/Create';
export const DebitNoteMaster_Update=DebitNoteMasterURL +'/Update';
export const DebitNoteMaster_Delete=DebitNoteMasterURL +'/Delete';
export const DebitNoteMaster_ReadById=DebitNoteMasterURL +'/ReadyById';
export const DebitNoteMaster_ReadByCompanyId=DebitNoteMasterURL +'/ReadyByCompanyId';
//endregion


//region Debitnotemaster api
export const JobWorkInMasterURL: string = Billing + '/JWIM';
export const JobWorkInMaster_Create = JobWorkInMasterURL + '/Create';
export const JobWorkInMaster_Update = JobWorkInMasterURL + '/Update';
export const JobWorkInMaster_Delete = JobWorkInMasterURL + '/Delete';
export const JobWorkInMaster_ReadById = JobWorkInMasterURL + '/ReadById';
export const JobWorkInMaster_ReadByCompanyId = JobWorkInMasterURL + '/ReadByCompanyId';
export const JobWorkInMaster_ReadByAgentId = JobWorkInMasterURL + '/ReadByAgentId';
export const JobWorkInMaster_ReadByJobWorkerId = JobWorkInMasterURL + '/ReadByJobWorkerId';
export const JobWorkInMaster_ReadByTransportId = JobWorkInMasterURL + '/ReadByTransportId';
export const JobWorkInMaster_ReadByJWOId = JobWorkInMasterURL + '/ReadByJWOId';
//endregion


//region Debitnotemaster api
export const JobWorkInDetailURL: string = Billing + '/JWID';
export const JobWorkInDetail_Create = JobWorkInDetailURL + '/Create';
export const JobWorkInDetail_Update = JobWorkInDetailURL + '/Update';
export const JobWorkInDetail_Delete = JobWorkInDetailURL + '/Delete';
export const JobWorkInDetail_ReadById = JobWorkInDetailURL + '/ReadById';
export const JobWorkInDetail_ReadByItemId = JobWorkInDetailURL + '/ReadByItemId';
export const JobWorkInDetail_ReadByJWIId = JobWorkInDetailURL + '/ReadByJWIId';
//endregion





// region Credit_detail api
export const CreditDetailURL: string = Billing + '/CND';
export const CreditDetail_Create= CreditDetailURL +'/Create';
export const CreditDetail_Update=CreditDetailURL +'/Update';
export const CreditDetail_Delete=CreditDetailURL +'/Delete';
export const CreditDetail_ReadByCreditNoteId=CreditDetailURL + '/ReadByCreditNoteId';
export const CreditDetail_ReadById=CreditDetailURL + '/ReadById';
export const CreditDetail_ReadByItemId=CreditDetailURL + '/ReadByItemId';
//endregion


// region Debit_detail api
export const  DebitDetailURL: string=Billing +'/DND';
export const  DebitDetail_Create=DebitDetailURL +'/Create';
export const DebitDetail_Update=DebitDetailURL +'/Update';
export const DebitDetail_Delete=DebitDetailURL+'/Delete';
export const DebitDetail_ReadById=DebitDetailURL+'/ReadById';
export const DebitDetail_ReadByItemId=DebitDetailURL+'/ReadByItemId';
export const DebitDetail_ReadByDebitNoteId=DebitDetailURL+'/ReadByDebitNoteId'
//endregion

//region JobWorkOutMaster API
export const JobWorkOutMasterURL: string = Billing + '/JWOM';
export const JobWorkOut_Create = JobWorkOutMasterURL + '/Create';
export const JobWorkOut_Update = JobWorkOutMasterURL + '/Update';
export const JobWorkOut_Delete = JobWorkOutMasterURL + '/Delete';
export const JobWorkOut_ReadById = JobWorkOutMasterURL + '/ReadById';
export const JobWorkOut_ReadAll = JobWorkOutMasterURL + '/ReadAll';
export const JobWorkOut_ReadByCompanyId = JobWorkOutMasterURL + '/ReadByCompanyId';
export const JobWorkOut_ReadByAgentId = JobWorkOutMasterURL + '/ReadByAgentId';
export const JobWorkOut_ReadByJobWorkerId = JobWorkOutMasterURL + '/ReadByJobWorkerId';
export const JobWorkOut_ReadByOrderId = JobWorkOutMasterURL + '/ReadByOrderId';
export const JobWorkOut_ReadByTransportId = JobWorkOutMasterURL + '/ReadByTransportId';
//endregion

//region JWOOutDetail API
export const JWOOutDetailURL: string = Billing + '/JOD';
export const JWOOutDetail_Create = JWOOutDetailURL + '/Create';
export const JWOOutDetail_Update = JWOOutDetailURL + '/Update';
export const JWOOutDetail_Delete = JWOOutDetailURL + '/Delete';
export const JWOOutDetail_ReadAll = JWOOutDetailURL + '/ReadAll';
export const JWOOutDetail_ReadById = JWOOutDetailURL + '/ReadById';
export const JWOOutDetail_ReadByItemId = JWOOutDetailURL + '/ReadByItemId';
export const JWOOutDetail_ReadByJWOId = JWOOutDetailURL + '/ReadByJWOId';
//endregion

//region InstructionsMaster API
export const InstructionsMasterURL: string = Billing + '/IM';
export const InstructionsMaster_Create = InstructionsMasterURL + '/Create';
export const InstructionsMaster_Update = InstructionsMasterURL + '/Update';
export const InstructionsMaster_Delete = InstructionsMasterURL + '/Delete';
export const InstructionsMaster_ReadById = InstructionsMasterURL + '/ReadById';
export const InstructionsMaster_ReadByMasterId = InstructionsMasterURL + '/ReadByMasterId'
//endregion

//region InstructionsMaster API
export const UnSubscribeAlertsURL: string = CRM + '/UA';
export const UnSubscribeAlerts_Create = UnSubscribeAlertsURL + '/Create';
export const UnSubscribeAlerts_Update = UnSubscribeAlertsURL + '/Update';
export const UnSubscribeAlerts_Delete = UnSubscribeAlertsURL + '/Delete';
export const UnSubscribeAlerts_ReadById = UnSubscribeAlertsURL + '/ReadById';
export const UnSubscribeAlerts_ReadByMasterId = UnSubscribeAlertsURL + '/ReadByMasterId'
//endregion

//region PrintTemplate API
export const PrintTemplateURL: string = NishwikMaster + '/PT';
export const PrintTemplate_Create = PrintTemplateURL + '/Create';
export const PrintTemplate_Update = PrintTemplateURL + '/Update';
export const PrintTemplate_Delete = PrintTemplateURL + '/Delete';
export const PrintTemplate_ReadAll = PrintTemplateURL + '/ReadAll';
export const PrintTemplate_ReadById = PrintTemplateURL + '/ReadById';
export const PrintTemplate_ReadByCompanyId = PrintTemplateURL + '/ReadByCompanyId'
//end region


//region PortMaster API
export const PortMasterURL: string = NishwikMaster + '/PM';
export const PortMaster_Create = PortMasterURL + '/Create';
export const PortMaster_Update = PortMasterURL + '/Update';
export const PortMaster_Delete = PortMasterURL + '/Delete';
export const PortMaster_ReadAll = PortMasterURL + '/ReadAll';
export const PortMaster_ReadAllPaginated = PortMasterURL + '/ReadAllPaginated';
export const PortMaster_ReadById = PortMasterURL + '/ReadById';
//end region

//region LabelMaster API
export const LabelMasterURL: string = Billing + '/LM';
export const LabelMaster_Create = LabelMasterURL + '/Create';
export const LabelMaster_Update = LabelMasterURL + '/Update';
export const LabelMaster_Delete = LabelMasterURL + '/Delete';
export const LabelMaster_ReadById = LabelMasterURL + '/ReadById';
export const LabelMaster_ReadAll = LabelMasterURL + '/ReadAll';
export const LabelMaster_ReadAllPaginated = LabelMasterURL + '/ReadAllPaginated';
//endregion


//region LabelDetail API
export const LabelDetailURL: string = Billing + '/LD';
export const LabelDetail_ReadAllPaginated = LabelDetailURL + '/ReadAllPaginated';
export const LabelDetail_Update = LabelDetailURL + '/Update';
export const LabelDetail_ReadById = LabelDetailURL + '/ReadById';
export const LabelDetail_ReadByLabelId = LabelDetailURL + '/ReadByLabelId';
export const LabelDetail_ReadByProductId = LabelDetailURL + '/ReadByProductId';
export const LabelDetail_ReadAll = LabelDetailURL + '/ReadAll';
export const LabelDetail_Delete = LabelDetailURL + '/Delete';
export const LabelDetail_Create = LabelDetailURL + '/Create';
//endregion

//region PrintMaster API
export const PrintMasterURL: string = Billing + '/PRT';
export const PrintMaster_PrintSaleInvoice = PrintMasterURL + '/PrintSalesInvoice';
export const PrintMaster_PrintItemLabel = PrintMasterURL + '/PrintItemLabel';
export const PrintMaster_PrintSaleQuotation = PrintMasterURL + '/PrintSalesQuotation';
export const PrintMaster_PrintDynamicSQL = PrintMasterURL + '/PrintDynamicSQL';
export const PrintMaster_PurchaseChallan = PrintMasterURL + '/PrintPurchaseChallan';
export const PrintMaster_SaleChallan = PrintMasterURL + '/PrintSaleChallan';
export const PrintMaster_SaleRelease = PrintMasterURL + '/PrintSaleRelease';

//endregion


//region SiteMaster API
export const SiteMasterURL: string = CRM + "/SM";
export const SiteMaster_Create = SiteMasterURL + '/Create';
export const SiteMaster_Update = SiteMasterURL + '/Update';
export const SiteMaster_Delete = SiteMasterURL + '/Delete';
export const SiteMaster_ReadById = SiteMasterURL + '/ReadById';
export const SiteMaster_ReadAll = SiteMasterURL + '/ReadAll';
export const SiteMaster_ReadAllPaginated = SiteMasterURL + '/ReadAllPaginated';
//end region


//region labeldesignMaster API
export const DesignURL: string = NishwikMaster + "/LD";
export const Design_Create = DesignURL + '/Create';
export const Design_Update = DesignURL + '/Update';
export const Design_Delete = DesignURL + '/Delete';
export const Design_ReadAll = DesignURL + '/ReadAll';
export const Design_ReadById = DesignURL + '/ReadById';
export const Design_ReadByCompanyId = DesignURL + '/ReadByCompanyId';
//end region

//region labeldesignMaster API
export const HotelTableMasterURL: string = ERP + "/HTM";
export const HotelTableMaster_Create = HotelTableMasterURL + '/Create';
export const HotelTableMaster_Update = HotelTableMasterURL + '/Update';
export const HotelTableMaster_UpdateStatus = HotelTableMasterURL + '/UpdateStatus';
export const HotelTableMaster_Delete = HotelTableMasterURL + '/Delete';
export const HotelTableMaster_ReadAll = HotelTableMasterURL + '/ReadAll';
export const HotelTableMaster_ReadById = HotelTableMasterURL + '/ReadById';
export const HotelTableMaster_ReadByCompanyId = HotelTableMasterURL + '/ReadByCompanyId';
//end region

//region ReceiptMaster API
export const ReceiptMasterURL: string = Billing + "/RM";
export const ReceiptMaster_Create = ReceiptMasterURL + '/Create';
export const ReceiptMaster_Update = ReceiptMasterURL + '/Update';
export const ReceiptMaster_Delete = ReceiptMasterURL + '/Delete';
export const ReceiptMaster_ReadAll = ReceiptMasterURL + '/ReadAll';
export const ReceiptMaster_ReadById = ReceiptMasterURL + '/ReadById';
export const ReceiptMaster_ReadByInvoiceId = ReceiptMasterURL + '/ReadByInvoiceId';
export const ReceiptMaster_ReadByCompanyId = ReceiptMasterURL + '/ReadByCompanyId';
//end region

//region ReceiptMaster API
export const ReceiptDetailURL: string = Billing + "/RD";
export const ReceiptDetail_Create = ReceiptDetailURL + '/Create';
export const ReceiptDetail_Update = ReceiptDetailURL + '/Update';
export const ReceiptDetail_Delete = ReceiptDetailURL + '/Delete';
export const ReceiptDetail_ReadAll = ReceiptDetailURL + '/ReadAll';
export const ReceiptDetail_ReadById = ReceiptDetailURL + '/ReadById';
export const ReceiptDetail_ReadByReceiptId = ReceiptDetailURL + '/ReadByReceiptId';
export const ReceiptDetail_ReadByInvoiceId = ReceiptDetailURL + '/ReadByInvoiceId';
export const ReceiptDetail_GetTransactionsByType = ReceiptDetailURL + '/GetTransactionsByType';
//end region

//region SizeMaster API
export const SizeMasterURL: string = NishwikMaster + "/SZM";
export const SizeMaster_Create = SizeMasterURL + '/Create';
export const SizeMaster_Update = SizeMasterURL + '/Update';
export const SizeMaster_Delete = SizeMasterURL + '/Delete';
export const SizeMaster_ReadAll = SizeMasterURL + '/ReadAll';
export const SizeMaster_ReadById = SizeMasterURL + '/ReadById';
export const SizeMaster_ReadByCompanyId = SizeMasterURL + '/ReadByCompanyId';
export const SizeMaster_SearchByName = SizeMasterURL + '/SearchByName'
//end region

//region CompanyDocumentNumber API
export const CompanyDocumentNumberURL: string = NishwikMaster + "/CDN";
export const CompanyDocumentNumber_Create = CompanyDocumentNumberURL + '/Create';
export const CompanyDocumentNumber_Update = CompanyDocumentNumberURL + '/Update';
export const CompanyDocumentNumber_Delete = CompanyDocumentNumberURL + '/Delete';
export const CompanyDocumentNumber_ReadAll = CompanyDocumentNumberURL + '/ReadAll';
export const CompanyDocumentNumber_ReadById = CompanyDocumentNumberURL + '/ReadById';
export const CompanyDocumentNumber_ReadByCompanyId = CompanyDocumentNumberURL + '/ReadByCompanyId';
export const CompanyDocumentNumber_GetMaxNumberByDocType = CompanyDocumentNumberURL + '/GetMaxNumberByDocType';
export const CompanyDocumentNumber_UpdateByDocType = CompanyDocumentNumberURL + '/UpdateByDocType'
export const CompanyDocumentNumber_GetBulkMaxNumberByDocType = CompanyDocumentNumberURL + '/GetBulkMaxNumberByDocType';
//end region

//region DestinationMaster API
export const DestinationMasterURL: string = ERP + '/DM';
export const DestinationMaster_Create = DestinationMasterURL + '/Create';
export const DestinationMaster_Update = DestinationMasterURL + '/Update';
export const DestinationMaster_Delete = DestinationMasterURL + '/Delete';
export const DestinationMaster_ReadAll = DestinationMasterURL + '/ReadAll';
export const DestinationMaster_ReadById = DestinationMasterURL + '/ReadById';
export const DestinationMaster_ReadByCompanyId = DestinationMasterURL+ '/ReadByCompanyId';
//end region

//region ConsignmentMaster API 
export const ConsignmentMasterURL: string = ERP + '/CM';
export const ConsignmentMaster_Create = ConsignmentMasterURL + '/Create';
export const ConsignmentMaster_Update = ConsignmentMasterURL + '/Update';
export const ConsignmentMaster_Delete = ConsignmentMasterURL + '/Delete';
export const ConsignmentMaster_ReadAll = ConsignmentMasterURL + '/ReadAll';
export const ConsignmentMaster_ReadById = ConsignmentMasterURL + '/ReadById';
export const ConsignmentMaster_ReadByCompanyId = ConsignmentMasterURL+ '/ReadByCompanyId';
export const ConsignmentMaster_ReadByOrderNo = ConsignmentMasterURL+ '/ReadByOrderNo';
export const ConsignmentMaster_ReadByDriverId = ConsignmentMasterURL+ '/ReadByDriverId';
export const ConsignmentMaster_ReadByBrokerId = ConsignmentMasterURL+ '/ReadByBrokerId';
//end region


//region ConsignmentCharges API
export const ConsignmentChargesURL: string = ERP + '/CC';
export const ConsignmentCharges_Create = ConsignmentChargesURL + '/Create';
export const ConsignmentCharges_Update = ConsignmentChargesURL + '/Update';
export const ConsignmentCharges_Delete = ConsignmentChargesURL + '/Delete';
export const ConsignmentCharges_ReadAll = ConsignmentChargesURL + '/ReadAll';
export const ConsignmentCharges_ReadById = ConsignmentChargesURL + '/ReadById';
export const ConsignmentCharges_ReadByConsignmentId = ConsignmentChargesURL+ '/ReadByConsignmentId';
//end region


//region ConsignmentEWayBill API
export const ConsignmentEWayBillsURL: string = ERP + '/CEB';
export const ConsignmentEWayBills_Create = ConsignmentEWayBillsURL + '/Create';
export const ConsignmentEWayBills_Update = ConsignmentEWayBillsURL + '/Update';
export const ConsignmentEWayBills_Delete = ConsignmentEWayBillsURL + '/Delete';
export const ConsignmentEWayBills_ReadAll = ConsignmentEWayBillsURL + '/ReadAll';
export const ConsignmentEWayBills_ReadById = ConsignmentEWayBillsURL + '/ReadById';
export const ConsignmentEWayBills_ReadByConsignmentId = ConsignmentEWayBillsURL+ '/ReadByConsignmentId';
//end region

//region DocMaster API
export const DocMasterURL: string = NishwikMaster + '/DCM';
export const DocMaster_Create: string = DocMasterURL + '/Create';
export const DocMaster_Update: string = DocMasterURL + '/Update';
export const DocMaster_ReadById: string = DocMasterURL + '/ReadById';
export const DocMaster_Delete: string = DocMasterURL + '/Delete';
export const DocMaster_ReadAll: string = DocMasterURL + '/ReadAll';
export const DocMaster_ReadByDocType: string = DocMasterURL + '/ReadByDocType';
export const DocMaster_ReadByMasterId: string = DocMasterURL + '/ReadByMasterId';
//end region


//region MsItemMaster API
export const MsItemMasterURL: string = ERP + "/MIM";
export const MsItemMaster_Create = MsItemMasterURL + '/Create';
export const MsItemMaster_Update = MsItemMasterURL + '/Update';
export const MsItemMaster_Delete = MsItemMasterURL + '/Delete';
export const MsItemMaster_ReadAll = MsItemMasterURL + '/ReadAll';
export const MsItemMaster_ReadById = MsItemMasterURL + '/ReadById';
export const MsItemMaster_ReadByCompanyId = MsItemMasterURL + '/ReadByCompanyId';
export const MsItemMaster_ReadAllPaginated = MsItemMasterURL + '/ReadAllPaginated';
export const MsItemMaster_ReadByItemNo = MsItemMasterURL + '/ReadByItemNo';
export const MsItemMaster_SearchByName = MsItemMasterURL + '/SearchByName';
//end region

//region MSPriceMaster API
export const MSPriceMasterURL: string = ERP + "/MPM";
export const MSPriceMaster_Create = MSPriceMasterURL + '/Create';
export const MSPriceMaster_Update = MSPriceMasterURL + '/Update';
export const MSPriceMaster_Delete = MSPriceMasterURL + '/Delete';
export const MSPriceMaster_ReadAll = MSPriceMasterURL + '/ReadAll';
export const MSPriceMaster_ReadById = MSPriceMasterURL + '/ReadById';
export const MSPriceMaster_ReadByItemId = MSPriceMasterURL + '/ReadByItemId';
//end region

//region Company Email Temaplate
export const CompanyEmailTemplateURL: string = NishwikMaster + "/CET";
export const CompanyEmailTemplate_Create = CompanyEmailTemplateURL + '/Create';
export const CompanyEmailTemplate_Update = CompanyEmailTemplateURL + '/Update';
export const CompanyEmailTemplate_Delete = CompanyEmailTemplateURL + '/Delete';
export const CompanyEmailTemplate_ReadAll = CompanyEmailTemplateURL + '/ReadAll';
export const CompanyEmailTemplate_ReadById = CompanyEmailTemplateURL + '/ReadById';
export const CompanyEmailTemplate_ReadByCompanyId = CompanyEmailTemplateURL + '/ReadByCompanyId';
export const CompanyEmailTemplate_ReadAllPaginated = CompanyEmailTemplateURL + '/ReadAllPaginated';
//end region


//region Company Email Temaplate
export const CompanyEmailTemplateVariableURL: string = NishwikMaster + "/CTV";
export const CompanyEmailTemplateVariable_Create = CompanyEmailTemplateVariableURL + '/Create';
export const CompanyEmailTemplateVariable_Update = CompanyEmailTemplateVariableURL + '/Update';
export const CompanyEmailTemplateVariable_Delete = CompanyEmailTemplateVariableURL + '/Delete';
export const CompanyEmailTemplateVariable_ReadAll = CompanyEmailTemplateVariableURL + '/ReadAll';
export const CompanyEmailTemplateVariable_ReadById = CompanyEmailTemplateVariableURL + '/ReadById';
export const CompanyEmailTemplateVariable_ReadByTemplateID = CompanyEmailTemplateVariableURL + '/ReadByTemplateId';
//end region


//region MSPriceMaster API
export const MsItemFilesURL: string = ERP + "/MSIF";
export const MsItemFiles_Create = MsItemFilesURL + '/Create';
export const MsItemFiles_Update = MsItemFilesURL + '/Update';
export const MsItemFiles_Delete = MsItemFilesURL + '/Delete';
export const MsItemFiles_ReadAll = MsItemFilesURL + '/ReadAll';
export const MsItemFiles_ReadById = MsItemFilesURL + '/ReadById';
export const MsItemFiles_ReadByItemId = MsItemFilesURL + '/ReadByItemId';
//end region


//region SampleMaster API
export const SampleMasterURL: string = Products + "/SM";
export const SampleMaster_Create = SampleMasterURL + '/Create';
export const SampleMaster_Update = SampleMasterURL + '/Update';
export const SampleMaster_Delete = SampleMasterURL + '/Delete';
export const SampleMaster_ReadAll = SampleMasterURL + '/ReadAll';
export const SampleMaster_ReadById = SampleMasterURL + '/ReadById';
export const SampleMaster_ReadByItemId = SampleMasterURL + '/ReadByItemId';
export const SampleMaster_ReadByItemNo = SampleMasterURL + '/ReadByItemNo';
//end region

//region SampleDetail API
export const SampleDetailURL: string = Products + "/SD";
export const SampleDetail_Create = SampleDetailURL + '/Create';
export const SampleDetail_Update = SampleDetailURL + '/Update';
export const SampleDetail_Delete = SampleDetailURL + '/Delete';
export const SampleDetail_ReadAll = SampleDetailURL + '/ReadAll';
export const SampleDetail_ReadById = SampleDetailURL + '/ReadById';
export const SampleDetail_ReadBySampleId = SampleDetailURL + '/ReadBySampleId';
//end region


//region MsItemStockMaster API
export const MsItemStockMasterURL: string = ERP + "/MSSM";
export const MsItemStockMaster_Create = MsItemStockMasterURL + '/Create';
export const MsItemStockMaster_Update = MsItemStockMasterURL + '/Update';
export const MsItemStockMaster_Delete = MsItemStockMasterURL + '/Delete';
export const MsItemStockMaster_ReadAll = MsItemStockMasterURL + '/ReadAll';
export const MsItemStockMaster_ReadById = MsItemStockMasterURL + '/ReadById';
export const MsItemStockMaster_ReadByItemId = MsItemStockMasterURL + '/ReadByItemId';
export const MsItemStockMaster_ReadByCompanyId = MsItemStockMasterURL + '/ReadByCompanyId';
//end region


//region TemplateMaster API
export const TemplateMasterURL: string = PMS + "/TM";
export const TemplateMaster_Create = TemplateMasterURL + '/Create';
export const TemplateMaster_Update = TemplateMasterURL + '/Update';
export const TemplateMaster_Delete = TemplateMasterURL + '/Delete';
export const TemplateMaster_ReadAll = TemplateMasterURL + '/ReadAll';
export const TemplateMaster_ReadById = TemplateMasterURL + '/ReadById';
export const TemplateMaster_ReadByExistingTemplateId = TemplateMasterURL + '/ReadByExistingTemplateId';
export const TemplateMaster_ReadByCompanyId = TemplateMasterURL + '/ReadByCompanyId';
export const TemplateMaster_ReadAllPaginated = TemplateMasterURL + '/ReadAllPaginated';
//end region

//region TemplateDetail API
export const TemplateDetailURL: string = PMS + "/TD";
export const TemplateDetail_Create = TemplateDetailURL + '/Create';
export const TemplateDetail_Update = TemplateDetailURL + '/Update';
export const TemplateDetail_Delete = TemplateDetailURL + '/Delete';
export const TemplateDetail_ReadAll = TemplateDetailURL + '/ReadAll';
export const TemplateDetail_ReadById = TemplateDetailURL + '/ReadById';
export const TemplateDetail_ReadByParentDetailId = TemplateDetailURL + '/ReadByParentDetailId';
export const TemplateDetail_ReadByTemplateId = TemplateDetailURL + '/ReadByTemplateId';
export const TemplateDetail_PrintMasterByTemplateId = TemplateDetailURL + '/PrintMasterByTemplateId';
//end region


//region Template Detail Task Estimate  API
export const TemplateDetailTaskEstimateURL: string = PMS + "/TDTE";
export const TemplateDetailTaskEstimate_Create = TemplateDetailTaskEstimateURL + '/Create';
export const TemplateDetailTaskEstimate_Update = TemplateDetailTaskEstimateURL + '/Update';
export const TemplateDetailTaskEstimate_Delete = TemplateDetailTaskEstimateURL + '/Delete';
export const TemplateDetailTaskEstimate_ReadAll = TemplateDetailTaskEstimateURL + '/ReadAll';
export const TemplateDetailTaskEstimate_ReadById = TemplateDetailTaskEstimateURL + '/ReadById';
export const TemplateDetailTaskEstimate_ReadByDetailId = TemplateDetailTaskEstimateURL + '/ReadByDetailId';
export const TemplateDetailTaskEstimate_ReadByTemplateId = TemplateDetailTaskEstimateURL + '/ReadByTemplateId';
export const TemplateDetailTaskEstimate_RolledUpByTemplateId = TemplateDetailTaskEstimateURL + '/RolledUpByTemplateId';
//end region

//region Template Milestone API
export const TemplateMilestone_URL: string = PMS + "/TMS";
export const TemplateMilestoneCreate = TemplateMilestone_URL + '/Create';
export const TemplateMilestoneUpdate = TemplateMilestone_URL + '/Update';
export const TemplateMilestoneDelete = TemplateMilestone_URL + '/Delete';
export const TemplateMilestoneReadAll = TemplateMilestone_URL + '/ReadAll';
export const TemplateMilestoneReadById = TemplateMilestone_URL + '/ReadById';
export const TemplateMilestoneReadByTemplateId = TemplateMilestone_URL + '/ReadByTemplateId';
export const TemplateMilestoneReadByDetailId = TemplateMilestone_URL + '/ReadByDetailId';
//end region

//region Template PhaseGate API
export const TemplatePhaseGate_URL: string = PMS + "/TPG";
export const TemplatePhaseGateCreate = TemplatePhaseGate_URL + '/Create';
export const TemplatePhaseGateUpdate = TemplatePhaseGate_URL + '/Update';
export const TemplatePhaseGateDelete = TemplatePhaseGate_URL + '/Delete';
export const TemplatePhaseGateReadAll = TemplatePhaseGate_URL + '/ReadAll';
export const TemplatePhaseGateReadById = TemplatePhaseGate_URL + '/ReadById';
export const TemplatePhaseGateReadByUnlockPGId = TemplatePhaseGate_URL + '/ReadByUnlockPGId';
export const TemplatePhaseGateReadByDetailId = TemplatePhaseGate_URL + '/ReadByDetailId';
export const TemplatePhaseGateReadByTemplateId = TemplatePhaseGate_URL + '/ReadByTemplateId';
//end region


//region Template Detail Dependency API
export const TemplateDependency_URL: string = PMS + "/TDD";
export const TemplateDependencyCreate = TemplateDependency_URL + '/Create';
export const TemplateDependencyUpdate = TemplateDependency_URL + '/Update';
export const TemplateDependencyDelete = TemplateDependency_URL + '/Delete';
export const TemplateDependencyReadAll = TemplateDependency_URL + '/ReadAll';
export const TemplateDependencyReadById = TemplateDependency_URL + '/ReadById';
export const TemplateDependencyReadByDetailId = TemplateDependency_URL + '/ReadByDetailId';
export const TemplateDependencyReadByDependedOn = TemplateDependency_URL + '/ReadByDependedOn';
export const TemplateDependencyReadByTemplateId = TemplateDependency_URL + '/ReadByTemplateId';
//end region

//region Template Detail CheckList API
export const TemplateDetailChecklistURL: string = PMS + "/TDCL";
export const TemplateDetailChecklist_Create = TemplateDetailChecklistURL + '/Create';
export const TemplateDetailChecklist_Update = TemplateDetailChecklistURL + '/Update';
export const TemplateDetailChecklist_Delete = TemplateDetailChecklistURL + '/Delete';
export const TemplateDetailChecklist_ReadAll = TemplateDetailChecklistURL + '/ReadAll';
export const TemplateDetailChecklist_ReadById = TemplateDetailChecklistURL + '/ReadById';
export const TemplateDetailChecklist_ReadByDetailId = TemplateDetailChecklistURL + '/ReadByDetailId';
export const TemplateDetailChecklist_ReadByTemplateId = TemplateDetailChecklistURL + '/ReadByTemplateId';
//end region

//region TemplateDatalist API
export const TemplateDatalistURL: string = PMS + "/TDDL";  
export const TemplateDatalist_Create = TemplateDatalistURL + '/Create';
export const TemplateDatalist_Update = TemplateDatalistURL + '/Update';
export const TemplateDatalist_Delete = TemplateDatalistURL + '/Delete';
export const TemplateDatalist_ReadAll = TemplateDatalistURL + '/ReadAll';
export const TemplateDatalist_ReadById = TemplateDatalistURL + '/ReadById';
export const TemplateDatalist_ReadByDetailId = TemplateDatalistURL + '/ReadByDetailId';
export const TemplateDatalist_ReadByTemplateId = TemplateDatalistURL + '/ReadByTemplateId';
//endregion

//region ProjectDatalist API
export const ProjectDatalistURL: string = PMS + "/PDDL";
export const ProjectDatalist_Create = ProjectDatalistURL + '/Create';
export const ProjectDatalist_Update = ProjectDatalistURL + '/Update';
export const ProjectDatalist_Delete = ProjectDatalistURL + '/Delete';
export const ProjectDatalist_ReadAll = ProjectDatalistURL + '/ReadAll';
export const ProjectDatalist_ReadById = ProjectDatalistURL + '/ReadById';
export const ProjectDatalist_ReadByDetailId = ProjectDatalistURL + '/ReadByDetailId';
export const ProjectDatalist_ReadByProjectId = ProjectDatalistURL + '/ReadByProjectId';
//endregion



//region Project Detail CheckList API
export const ProjectDetailChecklistURL: string = PMS + "/PDCL";
export const ProjectDetailChecklist_Create = ProjectDetailChecklistURL + '/Create';
export const ProjectDetailChecklist_Update = ProjectDetailChecklistURL + '/Update';
export const ProjectDetailChecklist_Delete = ProjectDetailChecklistURL + '/Delete';
export const ProjectDetailChecklist_ReadAll = ProjectDetailChecklistURL + '/ReadAll';
export const ProjectDetailChecklist_ReadById = ProjectDetailChecklistURL + '/ReadById';
export const ProjectDetailChecklist_ReadByDetailId = ProjectDetailChecklistURL + '/ReadByDetailId';
export const ProjectDetailChecklist_ReadByProjectId = ProjectDetailChecklistURL + '/ReadByProjectId';
//end region



//region Project Master API
export const ProjectMasterURL: string = PMS + "/PM";
export const ProjectMaster_Create = ProjectMasterURL + '/Create';
export const ProjectMaster_Update = ProjectMasterURL + '/Update';
export const ProjectMaster_Delete = ProjectMasterURL + '/Delete';
export const ProjectMaster_ReadAll = ProjectMasterURL + '/ReadAll';
export const ProjectMaster_ReadById = ProjectMasterURL + '/ReadById';
export const ProjectMaster_ReadByTemplateId = ProjectMasterURL + '/ReadByTemplateId';
export const ProjectMaster_ReadByCompanyId = ProjectMasterURL + '/ReadByCompanyId';
export const ProjectMaster_ReadAllPaginated = ProjectMasterURL + '/ReadAllPaginated';
//end region

//region Project Detail API
export const ProjectDetailURL: string = PMS + "/PD";
export const ProjectDetail_Create = ProjectDetailURL + '/Create';
export const ProjectDetail_Update = ProjectDetailURL + '/Update';
export const ProjectDetail_Delete = ProjectDetailURL + '/Delete';
export const ProjectDetail_ReadAll = ProjectDetailURL + '/ReadAll';
export const ProjectDetail_ReadById = ProjectDetailURL + '/ReadById';
export const ProjectDetail_ReadByProjectId = ProjectDetailURL + '/ReadByProjectId';
export const ProjectDetail_ReadByParentDetailId = ProjectDetailURL + '/ReadByParentDetailId';
export const ProjectDetail_RolledUpDates = ProjectDetailURL + '/RolledUpDates';
export const ProjectDetail_GetAllMilestone = ProjectDetailURL + '/GetAllMilestone';
export const ProjectDetail_PrintMasterByProjectId = ProjectDetailURL + '/PrintMasterByProjectId';
//end region

//region Project Detail Task Estimate  API
export const ProjectDetail_EstimateURL: string = PMS + "/PDE";
export const ProjectDetail_Estimate_Create = ProjectDetail_EstimateURL + '/Create';
export const ProjectDetail_Estimate_Update = ProjectDetail_EstimateURL + '/Update';
export const ProjectDetail_Estimate_Delete = ProjectDetail_EstimateURL + '/Delete';
export const ProjectDetail_Estimate_ReadAll = ProjectDetail_EstimateURL + '/ReadAll';
export const ProjectDetail_Estimate_ReadById = ProjectDetail_EstimateURL + '/ReadById';
export const ProjectDetail_Estimate_ReadByDetailId = ProjectDetail_EstimateURL + '/ReadByDetailId';
export const ProjectDetail_Estimate_ReadByProjectId = ProjectDetail_EstimateURL + '/ReadByProjectId';
//end region

//region Project Milestone API
export const ProjectMilestone_URL: string = PMS + "/PMS";
export const ProjectMilestoneCreate = ProjectMilestone_URL + '/Create';
export const ProjectMilestoneUpdate = ProjectMilestone_URL + '/Update';
export const ProjectMilestoneDelete = ProjectMilestone_URL + '/Delete';
export const ProjectMilestoneReadAll = ProjectMilestone_URL + '/ReadAll';
export const ProjectMilestoneReadById = ProjectMilestone_URL + '/ReadById';
export const ProjectMilestoneReadByProjectId = ProjectMilestone_URL + '/ReadByProjectId';
export const ProjectMilestoneReadByDetailId = ProjectMilestone_URL + '/ReadByDetailId';
//end region

//region Project PhaseGate API
export const ProjectPhaseGate_URL: string = PMS + "/PDPG";
export const ProjectPhaseGateCreate = ProjectPhaseGate_URL + '/Create';
export const ProjectPhaseGateUpdate = ProjectPhaseGate_URL + '/Update';
export const ProjectPhaseGateDelete = ProjectPhaseGate_URL + '/Delete';
export const ProjectPhaseGateReadAll = ProjectPhaseGate_URL + '/ReadAll';
export const ProjectPhaseGateReadById = ProjectPhaseGate_URL + '/ReadById';
export const ProjectPhaseGateReadByUnlockPGId = ProjectPhaseGate_URL + '/ReadByUnlockPGId';
export const ProjectPhaseGateReadByDetailId = ProjectPhaseGate_URL + '/ReadByDetailId';
export const ProjectPhaseGateReadByProjectId = ProjectPhaseGate_URL + '/ReadByProjectId';
//end region

//region Project Detail Dependency API
export const ProjectDetailDependency_URL: string = PMS + "/PDD";
export const ProjectDetailDependencyCreate = ProjectDetailDependency_URL + '/Create';
export const ProjectDetailDependencyUpdate = ProjectDetailDependency_URL + '/Update';
export const ProjectDetailDependencyDelete = ProjectDetailDependency_URL + '/Delete';
export const ProjectDetailDependencyReadAll = ProjectDetailDependency_URL + '/ReadAll';
export const ProjectDetailDependencyReadById = ProjectDetailDependency_URL + '/ReadById';
export const ProjectDetailDependencyReadByDetailId = ProjectDetailDependency_URL + '/ReadByDetailId';
export const ProjectDetailDependencyReadByDependedOn = ProjectDetailDependency_URL + '/ReadByDependedOn';
export const ProjectDetailDependencyReadByProjectId = ProjectDetailDependency_URL + '/ReadByProjectId';
//end region

//region Project Detail User Mapping Estimate API
export const ProjectDetailUserMappingEstimate_URL: string = PMS + "/PDUM";
export const ProjectDetailUserMappingEstimate_Create = ProjectDetailUserMappingEstimate_URL + '/Create';
export const ProjectDetailUserMappingEstimate_Update = ProjectDetailUserMappingEstimate_URL + '/Update';
export const ProjectDetailUserMappingEstimate_Delete = ProjectDetailUserMappingEstimate_URL + '/Delete';
export const ProjectDetailUserMappingEstimate_ReadAll = ProjectDetailUserMappingEstimate_URL + '/ReadAll';
export const ProjectDetailUserMappingEstimate_ReadById = ProjectDetailUserMappingEstimate_URL + '/ReadById';
export const ProjectDetailUserMappingEstimate_ReadByDetailId = ProjectDetailUserMappingEstimate_URL + '/ReadByDetailId';
export const ProjectDetailUserMappingEstimate_ReadByUserId = ProjectDetailUserMappingEstimate_URL + '/ReadByUserId';
//endregion

//region Project Detail Cost API
export const ProjectDetailCost_URL: string = PMS + "/PDC";
export const ProjectDetailCost_Create = ProjectDetailCost_URL + '/Create';
export const ProjectDetailCost_Update = ProjectDetailCost_URL + '/Update';
export const ProjectDetailCost_Delete = ProjectDetailCost_URL + '/Delete';
export const ProjectDetailCost_ReadAll = ProjectDetailCost_URL + '/ReadAll';
export const ProjectDetailCost_ReadById = ProjectDetailCost_URL + '/ReadById';
export const ProjectDetailCost_ReadByDetailId = ProjectDetailCost_URL + '/ReadByDetailId';
export const ProjectDetailCost_ReadByProjectId = ProjectDetailCost_URL + '/ReadByProjectId';
//endregion

//region Template Cost API
export const TemplateCost_URL: string = PMS + "/TDC";
export const TemplateCost_Create = TemplateCost_URL + '/Create';
export const TemplateCost_Update = TemplateCost_URL + '/Update';
export const TemplateCost_Delete = TemplateCost_URL + '/Delete';
export const TemplateCost_ReadAll = TemplateCost_URL + '/ReadAll';
export const TemplateCost_ReadById = TemplateCost_URL + '/ReadById';
export const TemplateCost_ReadByDetailId = TemplateCost_URL + '/ReadByDetailId';
export const TemplateCost_ReadByTemplateId = TemplateCost_URL + '/ReadByTemplateId';
//endregion

//region Template Datalist Option API
export const TemplateDatalistOption_URL: string = PMS + "/TDDLO"; 
export const TemplateDatalistOption_Create = TemplateDatalistOption_URL + '/Create';
export const TemplateDatalistOption_Update = TemplateDatalistOption_URL + '/Update';
export const TemplateDatalistOption_Delete = TemplateDatalistOption_URL + '/Delete';
export const TemplateDatalistOption_ReadAll = TemplateDatalistOption_URL + '/ReadAll';
export const TemplateDatalistOption_ReadById = TemplateDatalistOption_URL + '/ReadById';
export const TemplateDatalistOption_ReadByDatalistId = TemplateDatalistOption_URL + '/ReadByDatalistId';
//endregion

//region Project Datalist Option API
export const ProjectDatalistOption_URL: string = PMS + "/PDDLO"; 
export const ProjectDatalistOption_Create = ProjectDatalistOption_URL + '/Create';
export const ProjectDatalistOption_Update = ProjectDatalistOption_URL + '/Update';
export const ProjectDatalistOption_Delete = ProjectDatalistOption_URL + '/Delete';
export const ProjectDatalistOption_ReadAll = ProjectDatalistOption_URL + '/ReadAll';
export const ProjectDatalistOption_ReadById = ProjectDatalistOption_URL + '/ReadById';
export const ProjectDatalistOption_ReadByDatalistId = ProjectDatalistOption_URL + '/ReadByDatalistId';
//endregion


//region BI Report Master API
export const BIReportComponent_URL: string = BIR + "/RC";
export const BIReportComponentCreate = BIReportComponent_URL + '/Create';
export const BIReportComponentUpdate = BIReportComponent_URL + '/Update';
export const BIReportComponentDelete = BIReportComponent_URL + '/Delete';
export const BIReportComponentReadAll = BIReportComponent_URL + '/ReadAll';
export const BIReportComponentReadById = BIReportComponent_URL + '/ReadById';
//end region


//region BI Report Master API
export const BIReportMaster_URL: string = BIR + "/RM";
export const BIReportMasterCreate = BIReportMaster_URL + '/Create';
export const BIReportMasterUpdate = BIReportMaster_URL + '/Update';
export const BIReportMasterDelete = BIReportMaster_URL + '/Delete';
export const BIReportMasterReadAll = BIReportMaster_URL + '/ReadAll';
export const BIReportMasterReadById = BIReportMaster_URL + '/ReadById';
export const BIReportMasterReadByCompanyId = BIReportMaster_URL + '/ReadByCompanyId';
//end region


//region BI Report Detail API
export const BIReportDetail_URL: string = BIR + "/RD";
export const BIReportDetailCreate: string = BIReportDetail_URL + '/Create';
export const BIReportDetailUpdate: string = BIReportDetail_URL + '/Update';
export const BIReportDetailDelete: string = BIReportDetail_URL + '/Delete';
export const BIReportDetailReadAll: string = BIReportDetail_URL + '/ReadAll';
export const BIReportDetailReadById: string = BIReportDetail_URL + '/ReadById';
export const BIReportDetailReadByComponentId: string = BIReportDetail_URL + '/ReadByComponentId';
export const BIReportDetailReadByDBConnId: string = BIReportDetail_URL + '/ReadByDBConnId';
export const BIReportDetailReadByReportId: string = BIReportDetail_URL + '/ReadByReportId';
//end region


//region Scheme Master API
export const SchemeMaster_URL: string = ERP + '/SM';
export const SchemeMaster_Create: string = SchemeMaster_URL + '/Create';
export const SchemeMaster_Update = SchemeMaster_URL + '/Update';
export const SchemeMaster_Delete = SchemeMaster_URL + '/Delete';
export const SchemeMaster_ReadById = SchemeMaster_URL + '/ReadById';
export const SchemeMaster_ReadByIndId = SchemeMaster_URL + '/ReadByIndId';
export const SchemeMaster_ReadByCompanyId = SchemeMaster_URL + '/ReadByCompanyId';
export const SchemeMaster_ReadAll = SchemeMaster_URL + '/ReadAll';
export const SchemeMaster_ReadAllPaginated = SchemeMaster_URL + '/ReadAllPaginated'
//end region

//region Scheme Detail API
export const SchemeDetail_URL: string = ERP + '/SD';
export const SchemeDetail_Create = SchemeDetail_URL + '/Create';
export const SchemeDetail_Update = SchemeDetail_URL + '/Update';
export const SchemeDetail_Delete = SchemeDetail_URL + '/Delete';
export const SchemeDetail_ReadById = SchemeDetail_URL + '/ReadById';
export const SchemeDetail_ReadBySchemeId = SchemeDetail_URL + '/ReadBySchemeId';
export const SchemeDetail_ReadAll = SchemeDetail_URL + '/ReadAll';
export const SchemeDetail_ReadAllPaginated = SchemeDetail_URL + '/ReadAllPaginated';
//end region

//region Vechile Master API
export const VehicleMaster_URL: string = ERP + '/VA';
export const VehicleMaster_Create = VehicleMaster_URL + '/Create';
export const VehicleMaster_Update = VehicleMaster_URL + '/Update';
export const VehicleMaster_Delete = VehicleMaster_URL + '/Delete';
export const VehicleMaster_ReadById = VehicleMaster_URL + '/ReadById';
export const VehicleMaster_ReadAll = VehicleMaster_URL + '/ReadAll';
//endRegion

//region ObjectConfigMaster API
export const ObjectConfigMaster_URL: string = NishwikMaster + '/OCM';
export const ObjectConfigMaster_Create = ObjectConfigMaster_URL + '/Create';
export const ObjectConfigMaster_Update = ObjectConfigMaster_URL + '/Update';
export const ObjectConfigMaster_Delete = ObjectConfigMaster_URL + '/Delete';
export const ObjectConfigMaster_ReadAll = ObjectConfigMaster_URL + '/ReadAll';
export const ObjectConfigMaster_ReadById = ObjectConfigMaster_URL + '/ReadById';
export const ObjectConfigMaster_ReadByMenuId = ObjectConfigMaster_URL + '/ReadByMenuId';
//endRegion

//region CompanyPageConfig API
export const CompanyPageConfig_URL: string = NishwikMaster + '/CPC';
export const CompanyPageConfig_Create = CompanyPageConfig_URL + '/Create';
export const CompanyPageConfig_Update = CompanyPageConfig_URL + '/Update';
export const CompanyPageConfig_Delete = CompanyPageConfig_URL + '/Delete';
export const CompanyPageConfig_ReadAll = CompanyPageConfig_URL + '/ReadAll';
export const CompanyPageConfig_ReadById = CompanyPageConfig_URL + '/ReadById';
export const CompanyPageConfig_ReadByCompanyId = CompanyPageConfig_URL + '/ReadById';
//endRegion

//region SmsTemplate API
export const SmsTemplate_URL: string = Notification + '/SMST';
export const SmsTemplate_Create = SmsTemplate_URL + '/Create';
export const SmsTemplate_Update = SmsTemplate_URL + '/Update';
export const SmsTemplate_ReadById = SmsTemplate_URL + '/ReadById';
export const SmsTemplate_Delete = SmsTemplate_URL + '/Delete';
export const SmsTemplate_ReadByCompanyId = SmsTemplate_URL + '/ReadByCompanyId';
export const SmsTemplate_ReadAll = SmsTemplate_URL + '/ReadAll';
//endRegion

//region AI APIS
export const OpenAI_URL: string = AI + '/OA/GPT'
export const AskGPT = OpenAI_URL + '/AskChatGPT';
export const SmsTemplate_ReadAllPaginated =SmsTemplate_URL + '/ReadAllPaginated';
//endRegion

//region WhatsappTemplate API
export const WhatsappTemplate_URL: string = Notification + '/WAT';
export const WhatsappTemplate_Create = WhatsappTemplate_URL + '/Create';
export const WhatsappTemplate_Delete = WhatsappTemplate_URL + '/Delete';
export const WhatsappTemplate_ReadAllMetaTemplates = WhatsappTemplate_URL + '/ReadAllMetaTemplates';


//endRegion

//region ObjectConfigMapping APIS
export const ObjectConfigMapping_URL: string = NishwikMaster + '/OCMP';
export const ObjectConfigMapping_Create: string = ObjectConfigMapping_URL + '/Create';
export const ObjectConfigMapping_Update: string = ObjectConfigMapping_URL + '/Update';
export const ObjectConfigMapping_Delete: string = ObjectConfigMapping_URL + '/Delete';
export const ObjectConfigMapping_ReadAll: string = ObjectConfigMapping_URL + '/ReadAll';
export const ObjectConfigMapping_ReadById: string = ObjectConfigMapping_URL + '/ReadById';
export const ObjectConfigMapping_ReadByCompanyId: string = ObjectConfigMapping_URL + '/ReadByCompanyId';
export const ObjectConfigMapping_ReadByObjectId: string = ObjectConfigMapping_URL + '/ReadByObjectId';
export const ObjectConfigMapping_ReadByMenuId: string = ObjectConfigMapping_URL + '/ReadByMenuId';
export const ObjectConfigMapping_ReadByMenuCode : string = ObjectConfigMapping_URL + '/ReadByMenuCode'
//endRegion

//region SalesInvoiceOtherCharges APIS
export const SalesInvoiceOtherChargesMasterURL: string = Billing + '/SOC'
export const SalesInvoiceOtherCharges_create = SalesInvoiceOtherChargesMasterURL + "/Create";
export const SalesInvoiceOtherCharges_update = SalesInvoiceOtherChargesMasterURL + "/Update";
export const SalesInvoiceOtherCharges_delete = SalesInvoiceOtherChargesMasterURL + "/Delete";
export const SalesInvoiceOtherCharges_readById = SalesInvoiceOtherChargesMasterURL + "/ReadById";
export const SalesInvoiceOtherCharges_readByInvoiceId = SalesInvoiceOtherChargesMasterURL + "/ReadByInvoiceId";
export const SalesInvoiceOtherCharges_readAll = SalesInvoiceOtherChargesMasterURL + "/ReadAll";
//endRegion

//region DevOps = Team API
export const TeamMasterURL: string = DevOps + '/TM'
export const TeamMaster_Create = TeamMasterURL + "/Create";
export const TeamMaster_Update = TeamMasterURL + "/Update";
export const TeamMaster_Delete = TeamMasterURL + "/Delete";
export const TeamMaster_ReadById = TeamMasterURL + "/ReadById";
export const TeamMaster_ReadByCompanyId = TeamMasterURL + "/ReadByCompanyId";
export const TeamMaster_ReadAll = TeamMasterURL + "/ReadAll";
export const TeamMaster_ReadAllPaginated = TeamMasterURL + "/ReadAllPaginated";
//endRegion

//region DevOps = Team Detail API
export const TeamDetailURL: string = DevOps + '/TD'
export const TeamDetail_Create = TeamDetailURL + "/Create";
export const TeamDetail_Update = TeamDetailURL + "/Update";
export const TeamDetail_Delete = TeamDetailURL + "/Delete";
export const TeamDetail_ReadById = TeamDetailURL + "/ReadById";
export const TeamDetail_ReadByTeamId = TeamDetailURL + "/ReadByTeamId";
export const TeamDetail_ReadAll = TeamDetailURL + "/ReadAll";
//endRegion

//region DevOps = TeamBacklog Detail API
export const TeamBacklogURL: string = DevOps + '/TBL'
export const TeamBacklog_Create = TeamBacklogURL + "/Create";
export const TeamBacklog_Update = TeamBacklogURL + "/Update";
export const TeamBacklog_Delete = TeamBacklogURL + "/Delete";
export const TeamBacklog_ReadById = TeamBacklogURL + "/ReadById";
export const TeamBacklog_ReadByTeamId = TeamBacklogURL + "/ReadByTeamId";
export const TeamBacklog_ReadAll = TeamBacklogURL + "/ReadAll";
export const TeamBacklog_ReadByCompanyId = TeamBacklogURL + "/ReadByCompanyId";
export const TeamBacklog_ReadByProjectId = TeamBacklogURL + "/ReadByProjectId";
export const TeamBacklog_ReadAllPaginated = TeamBacklogURL + "/ReadAllPaginated";
//endRegion

//#region PmsPrint API
export const PmsPrintURL: string = NishwikMaster + '/PRM';
export const PmsPrint_Create = PmsPrintURL + '/Create';
export const PmsPrint_Update = PmsPrintURL + '/Update';
export const PmsPrint_Delete = PmsPrintURL + '/Delete';
export const PmsPrint_ReadAll = PmsPrintURL + '/ReadAll';
export const PmsPrint_ReadById = PmsPrintURL + '/ReadById';
export const PmsPrint_ReadByCompanyId = PmsPrintURL + '/ReadByCompanyId';
export const PmsPrint_ReadByMasterId = PmsPrintURL + '/ReadByMasterId';
export const PmsPrint_ReadByTemplateId = PmsPrintURL + '/ReadByTemplateId';
//#endregion

//region DevOps = BacklogTask API
export const BacklogTaskURL: string = DevOps + '/BLT'
export const BacklogTask_Create = BacklogTaskURL + "/Create";
export const BacklogTask_Update = BacklogTaskURL + "/Update";
export const BacklogTask_Delete = BacklogTaskURL + "/Delete";
export const BacklogTask_ReadAll = BacklogTaskURL + "/ReadAll";
export const BacklogTask_ReadById = BacklogTaskURL + "/ReadById";
export const BacklogTask_ReadByBacklogId = BacklogTaskURL + "/ReadByBacklogId";
//endRegion

//region DevOps = BacklogDiscussion API
export const BacklogDiscussionURL: string = DevOps + '/BLT'
export const BacklogDiscussion_Create = BacklogDiscussionURL + "/Create";
export const BacklogDiscussion_Update = BacklogDiscussionURL + "/Update";
export const BacklogDiscussion_Delete = BacklogDiscussionURL + "/Delete";
export const BacklogDiscussion_ReadAll = BacklogDiscussionURL + "/ReadAll";
export const BacklogDiscussion_ReadById = BacklogDiscussionURL + "/ReadById";
export const BacklogDiscussion_ReadByBacklogId = BacklogDiscussionURL + "/ReadByBacklogId";
//endRegion

//#region PmsPrint API
export const CustomHtmlMasterURL: string = NishwikMaster + '/CUS';
export const CustomHtmlMaster_Create = CustomHtmlMasterURL + '/Create';
export const CustomHtmlMaster_Update = CustomHtmlMasterURL + '/Update';
export const CustomHtmlMaster_Delete = CustomHtmlMasterURL + '/Delete';
export const CustomHtmlMaster_ReadAll = CustomHtmlMasterURL + '/ReadAll';
export const CustomHtmlMaster_ReadById = CustomHtmlMasterURL + '/ReadById';
export const CustomHtmlMaster_ReadByCompanyId = CustomHtmlMasterURL + '/ReadByCompanyId';
export const CustomHtmlMaster_ReadByMasterId = CustomHtmlMasterURL + '/ReadByMasterId';
export const CustomHtmlMaster_ReadByTemplateId = CustomHtmlMasterURL + '/ReadByTemplateId';
export const CustomHtmlMaster_ReadAllPaginated = CustomHtmlMasterURL + '/ReadAllPaginated';
export const CustomHtmlMaster_ReadByParentDivId = CustomHtmlMasterURL + '/ReadByParentDivId';
//#endregion

//#region Payroll - Component API
export const Payroll_ComponentURL: string = Payroll + '/CN';
export const Payroll_Component_Create = Payroll_ComponentURL + '/Create';
export const Payroll_Component_Update = Payroll_ComponentURL + '/Update';
export const Payroll_Component_Delete = Payroll_ComponentURL + '/Delete';
export const Payroll_Component_ReadAll = Payroll_ComponentURL + '/ReadAll';
export const Payroll_Component_ReadById = Payroll_ComponentURL + '/ReadById';
export const Payroll_Component_ReadByCompanyId = Payroll_ComponentURL + '/ReadByCompanyId';
//#endRegion


//#region Shift Master  API
export const ShiftMasterURL : string = HRMS + '/SM' ;
export const ShiftMaster_Create = ShiftMasterURL + '/Create';
export const ShiftMaster_Update = ShiftMasterURL + '/Update';
export const ShiftMaster_Delete = ShiftMasterURL + '/Delete';
export const ShiftMaster_ReadAll = ShiftMasterURL + '/ReadAll';
export const ShiftMaster_ReadById = ShiftMasterURL + '/ReadById';
export const ShiftMaster_ReadByCompanyId = ShiftMasterURL + '/ReadByCompanyId';


//#region Shift Detail API
export const ShiftDetailURL : string = HRMS + '/SD';
export const ShiftDetail_Create = ShiftDetailURL + '/Create';
export const ShiftDetail_Update = ShiftDetailURL + '/Update';
export const ShiftDetail_Delete = ShiftDetailURL + '/Delete';
export const ShiftDetail_ReadAll = ShiftDetailURL + '/ReadAll';
export const ShiftDetail_ReadById = ShiftDetailURL + '/ReadById';
export const ShiftDetail_ReadByShiftId = ShiftDetailURL + '/ReadByShiftId';



//#region Item Stock API
export const ItemStockURL: string = ERP + '/ITST';
export const ItemStock_Create = ItemStockURL + '/Create';
export const ItemStock_Update = ItemStockURL + '/Update';
export const ItemStock_Delete = ItemStockURL + '/Delete';
export const ItemStock_ReadAll = ItemStockURL + '/ReadAll';
export const ItemStock_ReadById = ItemStockURL + '/ReadById';
export const ItemStock_ReadByItemId = ItemStockURL + '/ReadByItemId';
//#endregion



//region MS Sales Detail
export const MSItemSalesDetailURL: string = ERP + '/MSD'
export const MSItemSalesDetail_Create = MSItemSalesDetailURL + "/Create";
export const MSItemSalesDetail_Update = MSItemSalesDetailURL + "/Update";
export const MSItemSalesDetail_Delete = MSItemSalesDetailURL + "/Delete";
export const MSItemSalesDetail_ReadById = MSItemSalesDetailURL + "/ReadById";
export const MSItemSalesDetail_ReadAll = MSItemSalesDetailURL + "/ReadAll";
export const MSItemSalesDetail_ReadByInvoiceId = MSItemSalesDetailURL + "/ReadByInvoiceId";
export const MSItemSalesDetail_ReadByItemId = MSItemSalesDetailURL + "/ReadByItemId";
export const MSItemSalesDetail_ReadByMrpId = MSItemSalesDetailURL + "/ReadByMrpId";
export const MSItemSalesDetail_ReadByPriceId = MSItemSalesDetailURL + "/ReadByPriceId";
//endRegion

//Credit Note Other charges
export const CreditNoteOtherChargesURL: string = Billing + '/CNOC';
export const CreditNoteOtherCharges_create = CreditNoteOtherChargesURL + "/Create";
export const CreditNoteOtherCharges_update = CreditNoteOtherChargesURL + "/Update";
export const CreditNoteOtherCharges_delete = CreditNoteOtherChargesURL + "/Delete";
export const CreditNoteOtherCharges_readById = CreditNoteOtherChargesURL + "/ReadById";
export const CreditNoteOtherCharges_readByCreditNoteId = CreditNoteOtherChargesURL + "/ReadByCreditNoteId";
export const CreditNoteOtherCharges_readAll = CreditNoteOtherChargesURL + "/ReadAll";
//endRegion

//Debit Note Other Charges
export const DebitNoteOtherChargesURL: string = Billing + '/DNOC';
export const DebitNoteOtherCharges_create = DebitNoteOtherChargesURL + "/Create";
export const DebitNoteOtherCharges_update = DebitNoteOtherChargesURL + "/Update";
export const DebitNoteOtherCharges_delete = DebitNoteOtherChargesURL + "/Delete";
export const DebitNoteOtherCharges_readById = DebitNoteOtherChargesURL + "/ReadById";
export const DebitNoteOtherCharges_readByDebitNoteId = DebitNoteOtherChargesURL + "/ReadByDebitNoteId";
export const DebitNoteOtherCharges_readAll = DebitNoteOtherChargesURL + "/ReadAll";
//endRegion

//region Service/Item Detail 
export const ItemDetailDatalistURL: string = Products + '/IDD';
export const ItemDetailDatalist_Create = ItemDetailDatalistURL + "/Create";
export const ItemDetailDatalist_Update = ItemDetailDatalistURL + "/Update";
export const ItemDetailDatalist_Delete = ItemDetailDatalistURL + "/Delete";
export const ItemDetailDatalist_ReadById = ItemDetailDatalistURL + "/ReadById";
export const ItemDetailDatalist_ReadByItemId = ItemDetailDatalistURL + "/ReadByItemId";
export const ItemDetailDatalist_ReadAll = ItemDetailDatalistURL + "/ReadAll";
//endregion

//region Facebook Integration API
export const IndentMasterURL: string = Billing + '/PIM';
export const IndentMaster_Create = IndentMasterURL + '/Create';
export const IndentMaster_Update = IndentMasterURL + '/Update';
export const IndentMaster_Delete = IndentMasterURL + '/Delete';
export const IndentMaster_ReadAll = IndentMasterURL + '/ReadAll';
export const IndentMaster_ReadById = IndentMasterURL + '/ReadById';
export const IndentMaster_ReadByCompanyId = IndentMasterURL + '/ReadByCompanyId';
//endregion

//region Facebook Integration API
export const IndentDetailURL: string = Billing + '/PID';
export const IndentDetail_Create = IndentDetailURL + '/Create';
export const IndentDetail_Update = IndentDetailURL + '/Update';
export const IndentDetail_Delete = IndentDetailURL + '/Delete';
export const IndentDetail_ReadAll = IndentDetailURL + '/ReadAll';
export const IndentDetail_ReadById = IndentDetailURL + '/ReadById';
export const IndentDetail_ReadByIndentId = IndentDetailURL + '/ReadByIndentId';
//endregion



//region Facebook Integration API
export const EPC_FacebookURL: string = EPC + '/FB/FC';
export const EPC_FacebookConfig_Create = EPC_FacebookURL + '/Create';
export const EPC_FacebookConfig_Register = EPC_FacebookURL + '/Register';
export const EPC_FacebookConfig_Update = EPC_FacebookURL + '/Update';
export const EPC_FacebookConfig_Delete = EPC_FacebookURL + '/Delete';
export const EPC_FacebookConfig_ReadAll = EPC_FacebookURL + '/ReadAll';
export const EPC_FacebookConfig_ReadById = EPC_FacebookURL + '/ReadById';
export const EPC_FacebookConfig_ReadByCompanyId = EPC_FacebookURL + '/ReadByCompanyId';
export const EPC_FacebookConfig_Dashboard = EPC_FacebookURL + '/Dashboard';
export const EPC_FacebookConfig_SyncAllLeads = EPC_FacebookURL + '/SyncAllLeads';
//endregion


//region ItemVendorPrice API
export const ItemVendorPriceURL: string = Billing +'/ITVP';
export const ItemVendorPrice_Create = ItemVendorPriceURL + '/Create';
export const ItemVendorPrice_Update = ItemVendorPriceURL + '/Update';
export const ItemVendorPrice_Delete = ItemVendorPriceURL + '/Delete';
export const ItemVendorPrice_ReadAll = ItemVendorPriceURL + '/ReadAll';
export const ItemVendorPrice_ReadById = ItemVendorPriceURL + '/ReadById';
export const ItemVendorPrice_ReadByItemId = ItemVendorPriceURL + '/ReadByItemId';
export const ItemVendorPrice_ReadByVendorId = ItemVendorPriceURL + '/ReadByVendorId';
//endregion




